<template>
  <!-- Container principal da página -->
  <div class="container-fluid login-page-container">
    <!-- Cabeçalho da página -->
    <header class="header">
      <div class="container">
        <!-- Logo -->
        <div class="logo">
          <img src="../assets/img/icon-gpi-nfse.svg" alt="Logo gpi e NFSE" />
        </div>
      </div>
    </header>

    <!-- ALERTA DE PRODUÇÃO RESTRITA / ATUALIZAÇÕES DA NOTA NACIONAL (Logo abaixo do Header) -->
    <div class="alerta-banner-nacional" v-if="this.numbers && this.numbers.linkProducaoRestrita">
      <div class="alerta-banner-content">
        <i class="pi pi-info-circle alerta-banner-icon"></i>
        <div class="alerta-banner-text">
          <strong>Atualização na API de Integração NFS-e Nacional (NT 009 - Versão Inicial Oficial):</strong>
          Foi disponibilizada a <strong>versão inicial oficial (Release 1)</strong> das evoluções da <strong>NT 009</strong> no ambiente de <strong>Homologação (Produção Restrita)</strong>.
          Ressaltamos que se trata de uma versão inicial sujeita a novas evoluções e que <strong>funcionará exclusivamente em Homologação</strong>. O ambiente de <strong>Produção</strong> segue com o esquema anterior vigente até a data de convergência.
          <a
            href="https://www.gov.br/nfse/pt-br/noticias/cgnfs-e-informa-disponibilizadas-no-ambiente-de-testes-o-release-1-das-evolucoes-da-nota-tecnica-009"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acesse a notícia oficial da NT 009
          </a>
          ou consulte o menu <strong>APIs de Integração</strong>.
        </div>
      </div>
    </div>

    <!-- ÁREA PRINCIPAL DA TELA DE LOGIN (CENTRALIZADA VERTICALMENTE NA TELA) -->
    <div class="login-main-section">
      <div class="grid-principal">
        <!-- COLUNA 1: BRASÃO / ENTIDADE E CONTATO -->
        <div class="container-contato-entidade">
          <div class="entidade">
            <!-- IMAGEM DO BRASAO CASO O CLIENTE TENHA NO S3-->
            <img
              class="icone-entidade"
              :src="this.numbers.caminhoLogo"
              style="width: 210px !important; max-height: 210px; object-fit: contain;"
              alt="Brasão da Entidade"
              v-if="!manutencao && !logoLogin && this.numbers && this.numbers.caminhoLogo"
            />

            <img
              :src="logoLogin"
              alt="Logo da Entidade"
              class="icone-entidade"
              v-show="exibirLogo"
              style="width: 210px !important; max-height: 210px; object-fit: contain;"
            />

            <!-- Nome da entidade -->
            <h1 class="nome-entidade" v-if="!manutencao && this.numbers && this.numbers.nomeEntidade">
              {{ this.numbers.nomeEntidade }}
            </h1>
            <h1 class="nome-entidade" v-if="!manutencao && this.numbers && this.numbers.nomeCliente">
              {{ this.numbers.nomeCliente }}
            </h1>
          </div>

          <div
            class="contato-cliente-box"
            v-if="showDadosCliente"
            v-html="renderMarkdown(numbers.msgContatoLogin)"
          ></div>
        </div>

        <!-- COLUNA 2: FORMULARIO DE LOGIN -->
        <div class="form-login">
          <!-- Formulário de login -->
          <form name="form" @submit.prevent="handleLogin">
            <!-- Título do formulário -->
            <div class="form-title-primary" v-if="!manutencao">
              <span class="form-title-primary">Entrar</span>
            </div>
            <!-- Banner de manutenção -->
            <div v-if="manutencao">
              <template>
                <img src="../assets/img/full-banner.png" />
              </template>
            </div>

            <!-- INPUT DO USUARIO -->
            <div v-if="!manutencao">
              <div class="input">
                <div class="input-user">
                  <span class="input-text">
                    <div class="input-wrapper">
                      <!-- Input com ícone dentro -->
                      <div class="input-with-icon">
                        <!-- Input para CPF/CNPJ -->
                        <input
                          class="p-inputtext p-component p-filled"
                          v-if="idSimoes === '19533831040781681800D2584C905F8A'"
                          @input="onInputLogin()"
                          @blur="consultarTipoAutenticacao()"
                          @change="consultarTipoAutenticacao()"
                          id="usuario"
                          type="text"
                          placeholder="CPF/CNPJ"
                          autocomplete="off"
                          tabindex="1"
                          v-model="login.nomeAcesso"
                        />
                        <!-- Input para usuário -->
                        <input
                          class="p-inputtext p-component p-filled"
                          v-else
                          @input="onInputLogin()"
                          @blur="consultarTipoAutenticacao()"
                          @change="consultarTipoAutenticacao()"
                          id="usuario"
                          type="text"
                          placeholder="Usuário"
                          autocomplete="off"
                          tabindex="1"
                          v-model="login.nomeAcesso"
                        />
                        <!-- Ícone dentro do input -->
                        <img src="../assets/icons/icon-user.svg" alt="icon user" class="input-icon" />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <!-- MENSAGEM DE ERRO CASO USUARIO E SENHA ERRADOS -->
            <div v-if="!manutencao">
              <!-- Mensagem de sessão expirada -->
              <template v-if="this.expired">
                <div class="warn-login-form" severity="warn">Sua sessão expirou efetue um novo Login!</div>
              </template>

              <!-- Mensagem de aviso (vigência vencida) -->
              <template v-if="this.aviso">
                <div class="warn-login-form" severity="warn">{{ this.aviso }}</div>
              </template>

              <!-- Mensagem de erro genérica -->
              <template v-if="this.mensagemErro">
                <div class="error-login-form" severity="error">{{ this.mensagemErro }}</div>
              </template>

              <!-- Erro de validação do nome de acesso -->
              <template v-if="validation.hasError('login.nomeAcesso')">
                <div class="error-login-form" severity="error">{{ validation.firstError('login.nomeAcesso') }}</div>
              </template>

              <!-- Erro de validação da senha -->
              <template v-else-if="exibirCampoSenha && validation.hasError('login.senhaAcesso')">
                <div class="error-login-form" severity="error">{{ validation.firstError('login.senhaAcesso') }}</div>
              </template>

              <!-- Erro genérico -->
              <template v-if="this.erro">
                <div class="error-login-form" severity="error">{{ this.erro }}</div>
              </template>
            </div>

            <!-- INPUT SENHA -->
            <div class="input" v-if="!manutencao && exibirCampoSenha">
              <div class="input-user">
                <span class="input-text">
                  <div class="input-with-icon">
                    <!-- Campo de senha -->
                    <input
                      @input="removerErro()"
                      id="senha"
                      type="password"
                      placeholder="Senha"
                      autocomplete="off"
                      tabindex="2"
                      v-model="login.senhaAcesso"
                      class="input-senha"
                      :class="{ error: validation.hasError('login.senhaAcesso') }"
                    />
                    <!-- Ícone de olho para visualização de senha -->
                    <img src="../assets/icons/icon-padlock.svg" alt="Mostrar senha" class="input-icon-padlock" />
                  </div>
                </span>
              </div>
            </div>

            <!-- LINK ESQUECEU SUA SENHA -->
            <div class="link-esqueceu-senha" v-if="!manutencao && !sistemaBloqueado && exibirCampoSenha">
              <a class="esqueceu-senha" @click="esqueceuSenha()">Esqueceu Sua Senha?</a>
            </div>

            <!-- BOTAO ENTRAR -->
            <div class="entrar" v-if="!manutencao && exibirCampoSenha">
              <span class="entrar-text">
                <button type="submit" class="btnEntrar" tabindex="3">Entrar</button>
              </span>

              <div class="divider-ou" v-if="exibirBotaoCertificado || exibirBotaoGov">
                <span>ou</span>
              </div>
            </div>

            <!-- BOTAO ENTRAR COM CERTIFICADO DIGITAL -->
            <div class="outros-login" :style="!exibirCampoSenha ? 'margin-top: 18px;' : ''" v-if="!manutencao && exibirBotaoCertificado">
              <a @click="showJanelaCertificado()" class="btn-certificado-digital" tabindex="4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="cert-icon-svg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"
                  />
                  <path
                    d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"
                  />
                </svg>
                Entrar com certificado digital
              </a>
            </div>

            <!-- DIVISOR OU ENTRE CERTIFICADO E GOV (quando a senha estiver oculta e ambos visíveis - Caso 3) -->
            <div class="divider-ou" v-if="!manutencao && !exibirCampoSenha && exibirBotaoCertificado && exibirBotaoGov">
              <span>ou</span>
            </div>

            <!-- BOTAO ENTRAR COM GOV.BR -->
            <div class="outros-login" :style="!exibirCampoSenha && !exibirBotaoCertificado ? 'margin-top: 18px;' : ''" v-if="!manutencao && exibirBotaoGov">
              <a @click="iniciarLoginGov()" class="btn-gov-br" :style="!exibirCampoSenha && !exibirBotaoCertificado ? 'margin-top: 0;' : ''" tabindex="5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  class="gov-icon-svg"
                >
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                </svg>
                <span>Entrar com <strong>gov.br</strong></span>
              </a>
            </div>
          </form>
        </div>

        <!-- FLEX DAS INFORMACOES -->
        <div class="container-infos" v-if="this.numbers && !manutencao">
          <!-- CARD NFSE EMITIDAS -->
          <div class="infos-text">
            <div class="stat-card card-nfse">
              <div class="stat-icon stat-icon-nfse">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 37 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon-recibo-svg"
                >
                  <path
                    d="M6.81959 47.5H30.1804C34.7343 47.5 37 45.2206 37 40.6385V7.38304C37 2.82334 34.7343 0.5 30.1804 0.5H6.81959C2.28822 0.5 0 2.82334 0 7.38398V40.6385C0 45.2197 2.28822 47.5 6.81959 47.5ZM6.9951 43.971C4.72942 43.971 3.5412 42.7645 3.5412 40.573V7.44945C3.5412 5.2795 4.72942 4.02897 7.01763 4.02897H30.0049C32.2922 4.02897 33.4588 5.25705 33.4588 7.44945V40.573C33.4588 42.7645 32.2922 43.971 30.0265 43.971H6.9951ZM10.1853 13.1923H26.8588C27.6285 13.1923 28.2226 12.5788 28.2226 11.8118C28.2226 11.0663 27.6294 10.4967 26.8588 10.4967H10.1853C9.37061 10.4967 8.79902 11.0663 8.79902 11.8118C8.79902 12.5788 9.37155 13.1923 10.1853 13.1923ZM10.1853 20.8433H26.8588C27.6285 20.8433 28.2226 20.2297 28.2226 19.4618C28.2226 18.7173 27.6294 18.1467 26.8588 18.1467H10.1853C9.37061 18.1467 8.79902 18.7173 8.79902 19.4618C8.79902 20.2288 9.37155 20.8433 10.1853 20.8433ZM10.1853 28.4942H18.0823C18.852 28.4942 19.4461 27.9022 19.4461 27.1567C19.4461 26.3898 18.852 25.7977 18.0823 25.7977H10.1843C9.36967 25.7977 8.79808 26.3898 8.79808 27.1567C8.79808 27.9022 9.37061 28.4942 10.1843 28.4942"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div class="stat-content">
                <span class="stat-number">{{ this.numbers.qtdeNotasEmitidasFormatado }}</span>
                <span class="stat-label">NFS-e emitidas</span>
              </div>
            </div>

            <!-- INFORMACAO DOS DEVIDO AO MUNICIPIO -->
            <div class="infos-text" v-if="false">
              <span id="text1" class="form-subtitle"
                >{{ this.formataValorReal(this.numbers.devidoMunic) }} Devido no Municipio.</span
              >
            </div>

            <!-- INFORMACAO DOS DEVIDO FORA DO MUNICIPIO -->
            <div class="infos-text" v-if="false">
              <span id="text1" class="form-subtitle"
                >{{ this.formataValorReal(this.numbers.devidoForaMunic) }} Devido Fora do Municipio.</span
              >
            </div>
          </div>

          <!-- CARD DAPS EMITIDOS -->
          <div class="infos-text">
            <div class="stat-card card-nfse">
              <div class="stat-icon stat-icon-nfse">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 37 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon-recibo-svg"
                >
                  <path
                    d="M6.81959 47.5H30.1804C34.7343 47.5 37 45.2206 37 40.6385V7.38304C37 2.82334 34.7343 0.5 30.1804 0.5H6.81959C2.28822 0.5 0 2.82334 0 7.38398V40.6385C0 45.2197 2.28822 47.5 6.81959 47.5ZM6.9951 43.971C4.72942 43.971 3.5412 42.7645 3.5412 40.573V7.44945C3.5412 5.2795 4.72942 4.02897 7.01763 4.02897H30.0049C32.2922 4.02897 33.4588 5.25705 33.4588 7.44945V40.573C33.4588 42.7645 32.2922 43.971 30.0265 43.971H6.9951ZM10.1853 13.1923H26.8588C27.6285 13.1923 28.2226 12.5788 28.2226 11.8118C28.2226 11.0663 27.6294 10.4967 26.8588 10.4967H10.1853C9.37061 10.4967 8.79902 11.0663 8.79902 11.8118C8.79902 12.5788 9.37155 13.1923 10.1853 13.1923ZM10.1853 20.8433H26.8588C27.6285 20.8433 28.2226 20.2297 28.2226 19.4618C28.2226 18.7173 27.6294 18.1467 26.8588 18.1467H10.1853C9.37061 18.1467 8.79902 18.7173 8.79902 19.4618C8.79902 20.2288 9.37155 20.8433 10.1853 20.8433ZM10.1853 28.4942H18.0823C18.852 28.4942 19.4461 27.9022 19.4461 27.1567C19.4461 26.3898 18.852 25.7977 18.0823 25.7977H10.1843C9.36967 25.7977 8.79808 26.3898 8.79808 27.1567C8.79808 27.9022 9.37061 28.4942 10.1843 28.4942"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div class="stat-content">
                <span class="stat-number">{{ this.numbers.qtdeDapsEmitidosFormatado }}</span>
                <span class="stat-label">{{ notaTomador ? 'Notas Fiscais Tomador' : 'DAPS emitidos' }}</span>
              </div>
            </div>
          </div>

          <!-- CARD CREDENCIAMENTOS -->
          <div class="infos-text">
            <div class="stat-card card-nfse">
              <div class="stat-icon stat-icon-nfse">
                <i class="pi pi-users"></i>
              </div>
              <div class="stat-content">
                <span class="stat-number">{{ this.numbers.qtdeCredenciamentosFormatado }}</span>
                <span class="stat-label">Credenciamentos</span>
              </div>
            </div>
          </div>

          <!-- INFO DA DENUNCIA -->
          <div class="denuncia" v-if="false">
            <div class="denuncia-col">
              <img src="../assets/img/denuncia.png" />
            </div>
            <div class="denuncia-text">
              <span class="form-subtitle">Realize uma Denúncia relacionada à Prestação de Serviços.</span>
              <div>
                <Button label="Denúncia Fiscal" class="btnDenuncia" @click="denunciaFiscal()" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CARROSSEL DE BOTÕES (Abaixo do formulário de login) -->
      <div class="login-carousel-wrapper">
        <Carousel :buttons="carouselButtons" />
      </div>
    </div>

    <!-- SEÇÃO COMPLEMENTAR: MURAL DE AVISOS (Abaixo da tela principal de login) -->
    <div class="login-complement-section">
      <!-- DIVISOR VISUAL (HR) SEPARANDO O CARROSSEL E O MURAL DE AVISOS -->
      <div class="login-divider-wrapper">
        <hr class="login-section-divider" />
      </div>

      <!-- MURAL DE AVISOS -->
      <div class="login-avisos-wrapper">
        <AvisosCarousel :buttons="AvisosCarousel" />
      </div>
    </div>

    <!-- DIALOG: APIS DE INTEGRAÇÃO -->
    <Dialog
      :visible.sync="showLinkRps"
      :modal="true"
      :closable="false"
      v-if="this.numbers && this.numbers.linkRps"
      class="dialog-modern-clean dialog-apis-modal"
      :style="{ width: '68vw', maxWidth: '1020px' }"
      style="backdrop-filter: blur(4px);"
    >
      <div class="modal-dialog-inner">
        <!-- HEADER -->
        <div class="modal-header-modern">
          <div class="modal-header-left">
            <div class="modal-header-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 16 16">
                <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"/>
              </svg>
            </div>
            <div>
              <h1 class="modal-header-title">Central de APIs de Integração e Web Services</h1>
              <p class="modal-header-desc">
                Selecione o modelo desejado abaixo para consultar documentação técnica, manuais e endpoints de conexão.
              </p>
            </div>
          </div>
          <button @click="showLinkRps = false" type="button" class="btn-modal-close" title="Fechar janela">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <!-- ABAS DE NAVEGAÇÃO SEGMENTADA (TABS) -->
        <div class="api-nav-pills">
          <!-- ABA 1: NOTA NACIONAL (DPS) -->
          <button
            type="button"
            class="api-nav-pill"
            :class="{ active: abaApiSelecionada === 'dps' }"
            @click="abaApiSelecionada = 'dps'"
            v-if="numbers && (numbers.linkProducaoRestrita || numbers.linkProducao)"
          >
            <div class="api-pill-icon dps">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>
              </svg>
            </div>
            <div class="api-pill-text">
              <span class="api-pill-title">Nota Nacional (Modelo DPS)</span>
              <span class="api-pill-sub">Novo Modelo / Reforma Tributária (IBS e CBS)</span>
            </div>
            <span class="api-pill-badge ativo">ATIVO</span>
          </button>

          <!-- ABA 2: ABRASF 2.04 -->
          <button
            type="button"
            class="api-nav-pill"
            :class="{ active: abaApiSelecionada === 'abrasf' }"
            @click="abaApiSelecionada = 'abrasf'"
            v-if="configs && configs.id"
          >
            <div class="api-pill-icon abrasf" :class="{ inativo: isAbrasfInativo }">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0zm1 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m3 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M1.5 7A1.5 1.5 0 0 0 0 8.5v2A1.5 1.5 0 0 0 1.5 12h13a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 14.5 7zm1 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m3 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"/>
              </svg>
            </div>
            <div class="api-pill-text">
              <span class="api-pill-title">Padrão Abrasf (Versão 2.04)</span>
              <span class="api-pill-sub" v-if="isAbrasfInativo">Ativo apenas para consultas</span>
              <span class="api-pill-sub" v-else>Web Service SOAP Tradicional (XML de Lote RPS)</span>
            </div>
            <span class="api-pill-badge inativo" v-if="isAbrasfInativo">INATIVO</span>
            <span class="api-pill-badge ativo" v-else>ATIVO</span>
          </button>
        </div>

        <!-- CONTEÚDO SCROLLÁVEL -->
        <div class="tutoriais-content-scroll api-content-scroll">
          <!-- CONTEÚDO DA ABA 1: NOTA NACIONAL (DPS) -->
          <div v-show="abaApiSelecionada === 'dps'" class="api-tab-pane">
            <!-- Card Informativo de Contexto -->
            <div class="api-guide-card">
              <div class="api-guide-header">
                <span class="api-guide-tag dps">
                  <i class="pi pi-info-circle"></i>
                  Sobre a Integração Nacional
                </span>
                <span class="api-badge-status-ativo">Modelo Padrão Nacional (DPS)</span>
              </div>
              <h3 class="api-guide-title">Emissão de NFS-e via Declaração de Prestação de Serviço (DPS)</h3>
              <p class="api-guide-desc">
                O modelo nacional padroniza o formato de comunicação para a emissão de notas fiscais de serviço eletrônicas,
                já preparado para a transição dos tributos <strong>IBS e CBS</strong> da Reforma Tributária.
                Recomendamos que sua equipe técnica ou empresa de software baixe a documentação mais recente abaixo.
              </p>
            </div>

            <!-- Seção 1: Pacote para Download -->
            <div class="api-section-title">
              <i class="pi pi-folder"></i>
              <span>1. Documentação Técnica e Pacote de Arquivos</span>
            </div>

            <div class="api-downloads-wrapper">
              <!-- Pacote de Homologação / Testes (XSD NT 009 - VERSÃO INICIAL OFICIAL) -->
              <div class="api-download-card homologacao">
                <div class="api-download-card-header">
                  <div class="api-download-badges">
                    <span class="api-badge-env homologacao">
                      <i class="pi pi-cog"></i>
                      Ambiente de Homologação / Testes
                    </span>
                    <span class="api-badge-xsd-inicial">
                      <i class="pi pi-file-edit"></i>
                      XSD NT 009 (VERSÃO INICIAL OFICIAL)
                    </span>
                  </div>
                  <span class="api-env-help">Para testes e adequação técnica prévia no ambiente de Produção Restrita</span>
                </div>

                <!-- Destaque Informativo sobre a NT 009 -->
                <div class="api-notice-nt009">
                  <div class="api-notice-nt009-icon">
                    <i class="pi pi-info-circle"></i>
                  </div>
                  <div class="api-notice-nt009-body">
                    <div class="api-notice-nt009-header">
                      <strong>XSD NT 009: Versão Inicial Oficial (Release 1)</strong>
                      <span class="api-notice-pill">Ambiente de Testes</span>
                    </div>
                    <p>
                      Foi disponibilizado o <strong>XSD na versão inicial oficial</strong> referente às evoluções da <strong>Nota Técnica 009</strong>.
                    </p>
                    <ul class="api-notice-points">
                      <li>
                        <strong>Versão Inicial:</strong> Trata-se da primeira entrega (Release 1) das evoluções da NT 009, portanto <u>está sujeita a novas alterações e evoluções</u> pelo Comitê Gestor da NFS-e.
                      </li>
                      <li>
                        <strong>Exclusivo para Homologação:</strong> A versão da NT 009 <u>só funcionará no ambiente de Homologação (Produção Restrita / Testes)</u>.
                      </li>
                      <li>
                        <strong>Produção Oficial Diferente:</strong> O ambiente de <u>Produção Oficial utiliza um XSD diferente (o esquema vigente atual)</u>. Não envie documentos no formato da NT 009 para a Produção até que seja divulgada a data oficial de convergência de homologação para produção.
                      </li>
                    </ul>
                    <div class="api-notice-footer">
                      <a
                        href="https://www.gov.br/nfse/pt-br/noticias/cgnfs-e-informa-disponibilizadas-no-ambiente-de-testes-o-release-1-das-evolucoes-da-nota-tecnica-009"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="api-link-noticia-oficial"
                      >
                        <i class="pi pi-external-link"></i>
                        <span>Clique aqui para acessar o comunicado oficial do CGNFS-e e entender todas as mudanças da NT 009</span>
                      </a>
                    </div>
                  </div>
                </div>

                <a
                  :href="urlDocDpsHomologacao"
                  target="_blank"
                  class="api-download-box homologacao"
                  title="Baixar pacote de documentação técnica para Homologação com XSD da NT 009 (Versão Inicial Oficial)"
                >
                  <div class="api-download-left">
                    <div class="api-download-icon-circle homologacao">
                      <i class="pi pi-download"></i>
                    </div>
                    <div class="api-download-details">
                      <div class="api-download-filename">
                        <strong>Pacote Nacional DPS - Homologação (NT 009 - Versão Inicial)</strong>
                        <span class="api-file-ext warning">ZIP</span>
                      </div>
                      <p class="api-download-sub">
                        Manual técnico atualizado, layout e novos Schemas XSD da NT 009 (Release 1) para testes no Web Service de Homologação.
                      </p>
                    </div>
                  </div>
                  <div class="api-download-action">
                    <span class="btn-download-action homologacao">
                      <i class="pi pi-download"></i>
                      Baixar Pacote (Homologação)
                    </span>
                  </div>
                </a>
              </div>

              <!-- Pacote de Produção Oficial (XSD VIGENTE) -->
              <div class="api-download-card producao">
                <div class="api-download-card-header">
                  <div class="api-download-badges">
                    <span class="api-badge-env producao">
                      <i class="pi pi-check-circle"></i>
                      Ambiente de Produção Oficial
                    </span>
                    <span class="api-badge-xsd-oficial">
                      <i class="pi pi-shield"></i>
                      XSD OFICIAL VIGENTE
                    </span>
                  </div>
                  <span class="api-env-help">Válido para emissão real - difere da NT 009 até a data de convergência</span>
                </div>

                <a
                  :href="urlDocDpsProducao"
                  target="_blank"
                  class="api-download-box producao"
                  title="Baixar pacote oficial de documentação técnica para Produção"
                >
                  <div class="api-download-left">
                    <div class="api-download-icon-circle producao">
                      <i class="pi pi-download"></i>
                    </div>
                    <div class="api-download-details">
                      <div class="api-download-filename">
                        <strong>Pacote Nacional DPS - Produção Oficial (Vigente)</strong>
                        <span class="api-file-ext">ZIP</span>
                      </div>
                      <p class="api-download-sub">
                        Manual de Integração vigente, Layout de Campos e Schemas XSD oficiais vigentes para emissão real com validade fiscal.
                      </p>
                    </div>
                  </div>
                  <div class="api-download-action">
                    <span class="btn-download-action producao">
                      <i class="pi pi-download"></i>
                      Baixar Pacote (Produção)
                    </span>
                  </div>
                </a>
              </div>
            </div>

            <!-- Seção 2: Endpoints / URLs -->
            <div class="api-section-title">
              <i class="pi pi-link"></i>
              <span>2. Endereços dos Web Services (Endpoints / URLs)</span>
            </div>

            <div class="api-endpoints-wrapper">
              <!-- Homologação -->
              <div class="api-endpoint-card homologacao" v-if="numbers && numbers.linkProducaoRestrita">
                <div class="api-endpoint-card-header">
                  <div class="api-endpoint-badge-box">
                    <span class="api-badge-env homologacao">
                      <i class="pi pi-cog"></i>
                      Ambiente de Homologação / Testes
                    </span>
                    <span class="api-badge-tag-xsd homologacao">
                      <i class="pi pi-file-edit"></i>
                      NT 009 (Versão Inicial)
                    </span>
                    <span class="api-env-help">Sem validade fiscal - exclusivo para desenvolvimento e testes com a NT 009</span>
                  </div>
                </div>
                <div class="api-endpoint-input-group">
                  <div class="api-endpoint-code-box">
                    <code>{{ numbers.linkProducaoRestrita }}</code>
                  </div>
                  <button
                    type="button"
                    class="btn-copy-url homologacao"
                    @click="copiarLinkProducaoRestrita()"
                    :disabled="loading"
                    title="Copiar URL de Homologação"
                  >
                    <i class="pi pi-copy"></i>
                    <span>Copiar URL</span>
                  </button>
                </div>
              </div>

              <!-- Produção -->
              <div class="api-endpoint-card producao" v-if="numbers && numbers.linkProducao">
                <div class="api-endpoint-card-header">
                  <div class="api-endpoint-badge-box">
                    <span class="api-badge-env producao">
                      <i class="pi pi-check-circle"></i>
                      Ambiente de Produção Oficial
                    </span>
                    <span class="api-badge-tag-xsd producao">
                      <i class="pi pi-shield"></i>
                      XSD Oficial Vigente
                    </span>
                    <span class="api-env-help">Com validade fiscal e jurídica - formato difere da NT 009 até a data de convergência</span>
                  </div>
                </div>
                <div class="api-endpoint-input-group">
                  <div class="api-endpoint-code-box">
                    <code>{{ numbers.linkProducao }}</code>
                  </div>
                  <button
                    type="button"
                    class="btn-copy-url producao"
                    @click="copiarLinkProducao()"
                    :disabled="loading"
                    title="Copiar URL de Produção"
                  >
                    <i class="pi pi-copy"></i>
                    <span>Copiar URL</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Dica para o usuário -->
            <div class="api-share-tip">
              <i class="pi pi-send"></i>
              <div>
                <strong>Precisa repassar à sua equipe de TI ou desenvolvedor do seu sistema?</strong>
                <p>Copie as URLs acima e encaminhe o arquivo ZIP com a documentação para os técnicos responsáveis pela integração do seu software emissor.</p>
              </div>
            </div>
          </div>

          <!-- CONTEÚDO DA ABA 2: ABRASF 2.04 -->
          <div
            v-show="abaApiSelecionada === 'abrasf'"
            class="api-tab-pane"
            v-if="configs && configs.id"
          >
            <!-- Alerta Informativo quando Inativo -->
            <div class="api-alert-inativo" v-if="isAbrasfInativo">
              <i class="pi pi-exclamation-triangle"></i>
              <div>
                <strong>Atenção: Modelo Abrasf Desativado para Emissão e Cancelamento</strong>
                <p>
                  Conforme Ato Conjunto RFB/CGIBS nº 4, com a obrigatoriedade do IBS/CBS o modelo Abrasf foi desativado para processamento e cancelamento de notas e está ativo apenas para consultas.
                </p>
              </div>
            </div>

            <!-- Card Informativo de Contexto -->
            <div class="api-guide-card">
              <div class="api-guide-header">
                <span class="api-guide-tag abrasf" :class="{ inativo: isAbrasfInativo }">
                  <i class="pi pi-info-circle"></i>
                  Sobre o Padrão Abrasf
                </span>
                <span class="api-badge-status-inativo" v-if="isAbrasfInativo">
                  Inativo (Apenas Consultas)
                </span>
                <span class="api-badge-status-ativo" v-else>
                  Ativo (Padrão Municipal Vigente)
                </span>
              </div>
              <h3 class="api-guide-title">Integração via Web Service SOAP (Lote de RPS - Versão 2.04)</h3>
              <p class="api-guide-desc" v-if="isAbrasfInativo">
                O modelo Abrasf foi desativado para processamento e cancelamento de notas e está ativo temporariamente apenas para consultas.
                Para novas emissões e cancelamentos de notas fiscais, utilize a integração via <strong>Nota Nacional (Modelo DPS)</strong>.
              </p>
              <p class="api-guide-desc" v-else>
                Modelo tradicional de integração utilizado pela maioria dos sistemas emissores e ERPs do mercado.
                O envio é realizado via Web Service SOAP por meio de arquivos XML de Lote de RPS.
                Permanece ativo e plenamente funcional para emissão regular no município.
              </p>
            </div>

            <!-- Seção 1: Pacote para Download -->
            <div class="api-section-title">
              <i class="pi pi-folder"></i>
              <span>1. Documentação Técnica e Pacote de Arquivos</span>
            </div>

            <a
              href="https://s3.us-east-1.amazonaws.com/el.com.br/nfse/layout_rps_2.04_102.zip"
              target="_blank"
              class="api-download-box"
            >
              <div class="api-download-left">
                <div class="api-download-icon-circle abrasf" :class="{ inativo: isAbrasfInativo }">
                  <i class="pi pi-download"></i>
                </div>
                <div class="api-download-details">
                  <div class="api-download-filename">
                    <strong>Manual e Schemas do Padrão Abrasf 2.04</strong>
                    <span class="api-file-ext">ZIP</span>
                  </div>
                  <p class="api-download-sub">
                    Manual de integração, esquemas XSD para validação de lotes de RPS, consultas e cancelamentos.
                  </p>
                </div>
              </div>
              <div class="api-download-action">
                <span class="btn-download-action">
                  <i class="pi pi-download"></i>
                  Baixar Pacote ZIP
                </span>
              </div>
            </a>

            <!-- Seção 2: Endpoint / URL -->
            <div class="api-section-title">
              <i class="pi pi-link"></i>
              <span>2. Endereço do Web Service (WSDL / Endpoint)</span>
            </div>

            <div class="api-endpoints-wrapper">
              <div class="api-endpoint-card" :class="isAbrasfInativo ? 'inativo' : 'producao'">
                <div class="api-endpoint-card-header">
                  <div class="api-endpoint-badge-box">
                    <span class="api-badge-env" :class="isAbrasfInativo ? 'inativo' : 'producao'">
                      <i :class="isAbrasfInativo ? 'pi pi-info-circle' : 'pi pi-check-circle'"></i>
                      {{ isAbrasfInativo ? 'Web Service SOAP (Apenas Consultas)' : 'Web Service SOAP em Produção' }}
                    </span>
                    <span class="api-env-help" v-if="isAbrasfInativo">
                      URL ativa apenas para consultas (processamento e cancelamento de notas desativados)
                    </span>
                    <span class="api-env-help" v-else>
                      URL para envio de lotes de RPS, consultas e cancelamentos
                    </span>
                  </div>
                </div>
                <div class="api-endpoint-input-group">
                  <div class="api-endpoint-code-box">
                    <code>{{ numbers.linkRps }}</code>
                  </div>
                  <button
                    type="button"
                    class="btn-copy-url"
                    :class="isAbrasfInativo ? 'inativo' : 'producao'"
                    @click="copiarLinkRps()"
                    :disabled="loading"
                    title="Copiar URL do Web Service"
                  >
                    <i class="pi pi-copy"></i>
                    <span>Copiar URL</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Dica para o usuário -->
            <div class="api-share-tip" v-if="isAbrasfInativo">
              <i class="pi pi-info-circle"></i>
              <div>
                <strong>Atenção para desenvolvedores e empresas de software:</strong>
                <p>O modelo Abrasf foi desativado para processamento e cancelamento de notas e está ativo apenas para consultas. Para emissão e cancelamento de novas notas, ajuste o seu sistema para utilizar o padrão <strong>Nota Nacional (Modelo DPS)</strong>.</p>
              </div>
            </div>
            <div class="api-share-tip" v-else>
              <i class="pi pi-send"></i>
              <div>
                <strong>Utiliza um ERP ou sistema emissor homologado no padrão Abrasf?</strong>
                <p>Informe a URL do Web Service acima nas configurações de NFS-e do seu software para estabelecer a comunicação direta com a prefeitura.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- RODAPÉ DO MODAL -->
        <div class="modal-actions-footer api-modal-footer">
          <button type="button" class="btn-modal-secondary" @click="showLinkRps = false">
            <i class="pi pi-times"></i>
            <span>Fechar Janela</span>
          </button>
        </div>
      </div>
    </Dialog>

    <!-- DIALOG: LISTA DE TUTORIAIS E DOCUMENTAÇÕES -->
    <Dialog
      :visible.sync="showTutoriaisDialog"
      :modal="true"
      :closable="false"
      :style="{ width: '65vw', maxWidth: '1050px' }"
    >
      <div class="esqueceu-senha-modal tutoriais-modal-container">
        <!-- HEADER -->
        <div class="header-container" style="align-items: flex-start; margin-bottom: 12px;">
          <div>
            <div style="display: flex; align-items: center; gap: 10px;">
              <i class="pi pi-book" style="font-size: 1.5rem; color: var(--primary-color, #193155);"></i>
              <h1 class="titulo-header" style="margin: 0; font-size: 22px; font-weight: 700; color: #0f172a;">
                Central de Tutoriais e Documentações
              </h1>
            </div>
            <p style="font-size: 13px; color: #64748b; margin: 6px 0 0 0; line-height: 1.4;">
              Vídeos instrucionais e Procedimentos Operacionais Padrão (POP) para orientação dos contribuintes e
              prestadores de serviços.
            </p>
          </div>
          <button @click="showTutoriaisDialog = false" type="button" class="btn-cancelar" title="Fechar janela">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <!-- ABAS DE NAVEGAÇÃO SEGMENTADA -->
        <div class="tutoriais-nav-pills">
          <button
            type="button"
            class="tutoriais-nav-pill"
            :class="{ active: abaTutorialSelecionada === 'videos' }"
            @click="abaTutorialSelecionada = 'videos'"
          >
            <i class="pi pi-video"></i>
            <span>Vídeos Tutoriais</span>
            <span class="tutoriais-count-badge">{{ tutoriais.length }}</span>
          </button>

          <button
            type="button"
            class="tutoriais-nav-pill"
            :class="{ active: abaTutorialSelecionada === 'documentos' }"
            @click="abaTutorialSelecionada = 'documentos'"
          >
            <i class="pi pi-file-pdf"></i>
            <span>Manuais e Documentos (PDF)</span>
            <span class="tutoriais-count-badge">{{ documentosTutoriais.length }}</span>
          </button>
        </div>

        <!-- CONTEÚDO SCROLLÁVEL -->
        <div class="tutoriais-content-scroll">
          <!-- CONTEÚDO: VÍDEOS -->
          <div v-show="abaTutorialSelecionada === 'videos'">
            <div class="tutoriais-info-banner">
              <i class="pi pi-info-circle"></i>
              <div>
                <strong>Treinamentos em Vídeo</strong>
                <p>Assista aos tutoriais passo a passo para aprender as principais rotinas do sistema NFS-e.</p>
              </div>
            </div>

            <div class="tutoriais-cards-list">
              <div
                v-for="(video, index) in tutoriais"
                :key="'video-' + index"
                class="tutorial-card tutorial-video-item"
              >
                <!-- Indicador visual / thumbnail -->
                <div class="tutorial-card-media video-media">
                  <span class="tutorial-step-badge">#{{ (index + 1).toString().padStart(2, '0') }}</span>
                  <i class="pi pi-play-circle tutorial-play-icon"></i>
                </div>

                <!-- Informações do Vídeo -->
                <div class="tutorial-card-details">
                  <div class="tutorial-card-topbar">
                    <h3 class="tutorial-card-title">{{ video.titulo }}</h3>
                    <span v-if="jaAssistido(video)" class="tutorial-status-tag status-concluido">
                      <i class="pi pi-check"></i> Assistido
                    </span>
                    <span v-else class="tutorial-status-tag status-pendente">
                      <i class="pi pi-video"></i> Vídeo Aula
                    </span>
                  </div>
                  <p class="tutorial-card-desc">{{ video.descricao }}</p>
                  <div class="tutorial-card-meta">
                    <span v-if="video.duracao" class="meta-item">
                      <i class="pi pi-clock"></i> {{ video.duracao }}
                    </span>
                    <span class="meta-item"> <i class="pi pi-desktop"></i> Reprodução online </span>
                  </div>
                </div>

                <!-- Ações -->
                <div class="tutorial-card-actions">
                  <button type="button" @click="assistirVideo(video)" class="tutoriais-btn-primary">
                    <i class="pi pi-play"></i>
                    <span>Assistir</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Rodapé: download do pacote completo -->
            <div v-if="numbers && numbers.linkTutoriais" class="tutoriais-download-footer">
              <div class="footer-download-info">
                <i class="pi pi-cloud-download"></i>
                <div>
                  <strong style="color: #0f172a; font-size: 13.5px; display: block; margin-bottom: 2px;"
                    >Download dos Vídeos (.zip)</strong
                  >
                  <span style="color: #64748b; font-size: 12px; line-height: 1.4; display: block;"
                    >Baixe todos os tutoriais em arquivo compactado para visualização offline.</span
                  >
                </div>
              </div>
              <button type="button" @click="baixarTutoriais" class="tutoriais-btn-secondary" style="flex-shrink: 0;">
                <i class="pi pi-download"></i>
                <span>Baixar Pacote de Vídeos (.zip)</span>
              </button>
            </div>
          </div>

          <!-- CONTEÚDO: DOCUMENTOS (PDF) -->
          <div v-show="abaTutorialSelecionada === 'documentos'">
            <div class="tutoriais-info-banner">
              <i class="pi pi-info-circle"></i>
              <div>
                <strong>Procedimentos Operacionais Padrão (POP)</strong>
                <p>
                  Consulte e faça o download dos manuais oficiais com instruções detalhadas de operação das rotinas
                  municipais.
                </p>
              </div>
            </div>

            <div class="tutoriais-cards-list">
              <div
                v-for="(doc, index) in documentosTutoriais"
                :key="'doc-' + index"
                class="tutorial-card tutorial-doc-item"
              >
                <!-- Indicador visual / PDF -->
                <div class="tutorial-card-media doc-media">
                  <i class="pi pi-file-pdf tutorial-pdf-icon"></i>
                  <span class="tutorial-pdf-label">PDF</span>
                </div>

                <!-- Informações do Documento -->
                <div class="tutorial-card-details">
                  <div class="tutorial-card-topbar">
                    <h3 class="tutorial-card-title">{{ doc.titulo }}</h3>
                    <span v-if="doc.categoria" class="tutorial-status-tag status-doc">
                      <i class="pi pi-bookmark"></i> {{ doc.categoria }}
                    </span>
                  </div>
                  <p class="tutorial-card-desc">{{ doc.descricao }}</p>
                  <div class="tutorial-card-meta">
                    <span v-if="doc.tamanho" class="meta-item"> <i class="pi pi-database"></i> {{ doc.tamanho }} </span>
                    <span v-if="doc.formato" class="meta-item">
                      <i class="pi pi-file"></i> Formato {{ doc.formato }}
                    </span>
                    <span class="meta-item"> <i class="pi pi-check-circle"></i> Documento Oficial </span>
                  </div>
                </div>

                <!-- Ações -->
                <div class="tutorial-card-actions doc-actions">
                  <button type="button" @click="abrirDocumento(doc)" class="tutoriais-btn-primary">
                    <i class="pi pi-eye"></i>
                    <span>Visualizar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- DIALOG: PLAYER DE VIDEO -->
    <Dialog
      :visible.sync="showVideoDialog"
      :modal="true"
      :closable="false"
      :style="{ width: '70vw', maxWidth: '1100px' }"
    >
      <div class="esqueceu-senha-modal" v-if="videoAtual">
        <div class="header-container" style="align-items: center;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <i class="pi pi-video" style="font-size: 1.3rem; color: var(--primary-color, #193155);"></i>
            <h1 class="titulo-header" style="margin: 0; font-size: 20px;">{{ videoAtual.titulo }}</h1>
          </div>
          <button @click="fecharVideo()" type="button" class="btn-cancelar" title="Fechar vídeo">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>
        <div style="margin-top: 16px; text-align: center;">
          <video
            :key="videoAtual.url"
            controls
            autoplay
            style="width: 100%; max-height: 65vh; border-radius: 8px; background: #000; box-shadow: 0 4px 20px rgba(0,0,0,0.25);"
          >
            <source :src="videoAtual.url" type="video/mp4" />
            Seu navegador não suporta a reprodução de vídeo.
          </video>
        </div>
        <div
          style="margin-top: 14px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;"
        >
          <button type="button" @click="fecharVideo()" class="tutoriais-btn-secondary">
            <i class="pi pi-arrow-left"></i>
            <span>Voltar aos Tutoriais</span>
          </button>
          <span style="font-size: 12px; color: #64748b;">
            <i class="pi pi-info-circle"></i> O progresso deste vídeo foi salvo automaticamente.
          </span>
        </div>
      </div>
    </Dialog>

    <!-- LINK DO ESQUECEU A SENHA -->
    <!-- Modal para recuperação de senha, sincronizando visibilidade com 'showEsqueceu' -->
    <Dialog
      :visible.sync="showEsqueceu"
      :modal="true"
      :closable="false"
      class="dialog-modern-clean dialog-esqueceu-senha"
      :style="{ width: '500px', maxWidth: '92vw' }"
      style="backdrop-filter: blur(4px);"
    >
      <div class="modal-dialog-inner">
        <!-- Cabeçalho do modal -->
        <div class="modal-header-modern">
          <div class="modal-header-left">
            <div class="modal-header-icon">
              <i class="pi pi-key"></i>
            </div>
            <div>
              <h1 class="modal-header-title">Esqueceu sua Senha?</h1>
              <p class="modal-header-desc">
                Informe os dados cadastrados para receber as instruções de recuperação.
              </p>
            </div>
          </div>
          <button @click="hideNovaSenha()" type="button" class="btn-modal-close" title="Fechar janela">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <!-- Formulário de recuperação -->
        <div class="modal-form-body">
          <!-- Campo Tipo de Pessoa -->
          <div class="modal-form-group">
            <label for="tipoPessoa" class="modal-form-label">
              <i class="pi pi-user"></i>
              <span>Tipo de Pessoa:</span>
            </label>
            <Dropdown
              id="tipoPessoa"
              v-model="selectedTipoPessoa"
              :options="tiposPessoa"
              optionLabel="name"
              placeholder="Selecione um Tipo de Pessoa"
              class="modal-dropdown-field"
            />
          </div>

          <!-- Campo Documento com máscara (CPF ou CNPJ) -->
          <div class="modal-form-group">
            <label for="recuperaLogin" class="modal-form-label">
              <i class="pi pi-id-card"></i>
              <span>{{ selectedTipoPessoa && selectedTipoPessoa.key === 'F' ? 'CPF do Titular:' : 'CNPJ da Entidade/Empresa:' }}</span>
            </label>
            <div class="modal-input-wrapper">
              <template v-if="selectedTipoPessoa && selectedTipoPessoa.key === 'F'">
                <InputMask
                  id="recuperaLogin"
                  type="text"
                  placeholder="000.000.000-00"
                  autocomplete="off"
                  v-model="loginNovaSenha"
                  mask="999.999.999-99"
                  key="F"
                  class="modal-input-field"
                />
              </template>
              <template v-else>
                <InputMask
                  id="recuperaLogin"
                  type="text"
                  placeholder="00.000.000/0000-00"
                  autocomplete="off"
                  v-model="loginNovaSenha"
                  mask="**.***.***/****-99"
                  key="J"
                  style="text-transform: uppercase;"
                  class="modal-input-field"
                />
              </template>
            </div>
          </div>

          <!-- Informativo -->
          <div class="modal-notice-box">
            <i class="pi pi-info-circle"></i>
            <span>As orientações para redefinição de senha serão enviadas para o endereço de e-mail cadastrado.</span>
          </div>
        </div>

        <!-- Rodapé com ações -->
        <div class="modal-actions-footer">
          <Button
            label="Voltar"
            type="button"
            class="btn-modal-secondary"
            id="btnVoltar"
            @click="hideJanelaSenha()"
            icon="pi pi-arrow-left"
            :disabled="loading"
          />
          <Button
            @click="requisitarNovaSenha()"
            label="Recuperar Senha"
            class="btn-modal-primary"
            icon="pi pi-send"
            :disabled="loading"
          />
        </div>
      </div>
    </Dialog>

    <!-- IMPORTAR CERTIFICADO DIGITAL -->
    <!-- Modal para seleção de certificado digital, com visibilidade controlada pela variável 'showCertificado' -->
    <Dialog
      :visible.sync="showCertificado"
      :modal="true"
      :closable="false"
      class="dialog-modern-clean dialog-certificado"
      :style="{ width: '500px', maxWidth: '92vw' }"
      style="backdrop-filter: blur(4px);"
    >
      <div class="modal-dialog-inner">
        <!-- Cabeçalho do modal -->
        <div class="modal-header-modern">
          <div class="modal-header-left">
            <div class="modal-header-icon cert-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"
                />
                <path
                  d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"
                />
              </svg>
            </div>
            <div>
              <h1 class="modal-header-title">Certificado Digital</h1>
              <p class="modal-header-desc">
                Autenticação segura via e-CPF ou e-CNPJ (A1 / A3)
              </p>
            </div>
          </div>
          <button @click="hideJanelaCertificado()" type="button" class="btn-modal-close" title="Fechar janela">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <!-- Estado 1: Carregando certificado -->
        <div v-if="showCarregarCert" class="cert-loading-body">
          <div class="cert-spinner-wrapper">
            <i class="pi pi-spin pi-spinner cert-loading-spinner"></i>
          </div>
          <h4 class="cert-loading-title">Aguarde, comunicando com o módulo digital...</h4>
          <p class="cert-loading-desc">
            Estamos preparando a conexão com o certificado. Se solicitado pelo navegador, selecione seu certificado e confirme o PIN.
          </p>
        </div>

        <!-- Estado 2: Orientação e botão de ação -->
        <div v-if="!showCarregarCert" class="cert-modal-body">
          <div class="cert-info-card">
            <div class="cert-info-badge">
              <i class="pi pi-shield"></i>
            </div>
            <div class="cert-info-text">
              <strong>Padrão ICP-Brasil</strong>
              <p>Certifique-se de que o seu certificado digital está corretamente instalado e acessível neste navegador.</p>
            </div>
          </div>

          <div class="cert-step-list">
            <div class="cert-step-item">
              <div class="cert-step-number">1</div>
              <div class="cert-step-desc">
                Conecte o token/smartcard na porta USB ou confirme a instalação do arquivo A1 no dispositivo.
              </div>
            </div>
            <div class="cert-step-item">
              <div class="cert-step-number">2</div>
              <div class="cert-step-desc">
                Ao clicar em <strong>"Carregar Certificado"</strong>, selecione seu certificado na janela de confirmação do navegador.
              </div>
            </div>
          </div>

          <!-- Rodapé com ações -->
          <div class="modal-actions-footer">
            <Button
              label="Voltar"
              type="button"
              class="btn-modal-secondary"
              id="btnVoltar"
              @click="hideJanelaCertificado()"
              icon="pi pi-arrow-left"
              :disabled="loading"
            />
            <Button
              @click="carregarCertificado()"
              label="Carregar Certificado"
              class="btn-modal-primary"
              icon="pi pi-shield"
              :disabled="loading"
            />
          </div>
        </div>
      </div>
    </Dialog>

    <!-- Modal para validação do reCAPTCHA, com visibilidade controlada pela variável 'showCaptcha' -->
    <Dialog
      header="Necessária Validação do reCAPTCHA"
      :visible.sync="showCaptcha"
      :modal="true"
      :closable="false"
      :style="{ width: '25vw' }"
    >
      <!-- Contêiner principal do modal com rolagem -->
      <div class="container scrolable-dialog">
        <!-- Linha para posicionar o reCAPTCHA -->
        <div class="row">
          <!-- Centraliza o componente VueRecaptcha horizontalmente e verticalmente -->
          <div class="d-flex justify-content align-items-center" style="margin: 0 auto;">
            <!-- Componente VueRecaptcha que dispara o método 'handleSuccess' ao ser verificado -->
            <VueRecaptcha @verify="handleSuccess" :sitekey="siteKey" :load-recaptcha-script="true"></VueRecaptcha>
          </div>
        </div>
      </div>
    </Dialog>

    <!-- DIALOG: AVISO POPUP NA TELA DE LOGIN (TIPO SELEÇÃO 'P') -->
    <Dialog
      :visible.sync="showAvisoPopupLogin"
      :modal="true"
      :closable="false"
      :dismissableMask="true"
      @hide="onHideAvisoPopupLogin"
      v-if="avisoPopupLogin"
      class="dialog-modern-clean dialog-comunicado-nacional"
      :style="{ width: '860px', maxWidth: '94vw' }"
      style="backdrop-filter: blur(4px);"
    >
      <div class="comunicado-nacional-modal">
        <div class="comunicado-nacional-header">
          <div class="comunicado-nacional-header-title">
            <i class="pi pi-bell"></i>
            <span>{{ avisoPopupLogin.titulo || 'Comunicado Importante — NFS-e' }}</span>
          </div>
          <button
            @click="fecharAvisoPopupLogin()"
            type="button"
            class="btn-modal-close"
            title="Fechar comunicado e prosseguir com login"
          >
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <div class="comunicado-nacional-body">
          <!-- Conteúdo HTML (Editor) do aviso do tipo texto -->
          <div
            v-if="avisoPopupLogin.tipo === 'T' && exibirMensagemHtmlPopup"
            class="comunicado-nacional-html"
            :class="{ 'has-link': !!linkDestinoAvisoPopup }"
            v-html="avisoPopupLogin.mensagem"
            @click="onClickConteudoPopup($event)"
          ></div>
        </div>

        <div class="comunicado-nacional-footer">
          <button
            type="button"
            class="btn-modal-primary"
            @click="fecharAvisoPopupLogin()"
          >
            <span>Fechar e prosseguir com o login</span>
          </button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { marked } from 'marked';
// Importações necessárias
import Carousel from '../components/global/Carousel.vue'; // Importa o componente de carrossel global
import AvisosCarousel from '../components/global/AvisosCarousel.vue'; // Importação correta
import Login from '../models/acesso/Login'; // Importa o modelo de login
import LoginService from '../services/acesso/login.service'; // Importa o serviço de login
import GovService from '../services/acesso/gov.service'; // Importa o serviço de autenticação GOV.BR
import Numero from '../services/nfse/numeros'; // Importa o serviço de manipulação de números (relacionado à NFSe)
import DnsClienteService from '../services/nfse/dns.cliente.service'; // Importa o serviço de DNS para cliente relacionado a NFSe
import SimpleVueValidation from 'simple-vue-validator'; // Importa a biblioteca de validação "SimpleVueValidation"
const Validator = SimpleVueValidation.Validator; // Define uma constante para o validador de formulários

const renderer = new marked.Renderer();

renderer.link = (href, title, text) => {
  return `<a href="${href}" target="_blank" rel="noopener noreferrer"${title ? ` title="${title}"` : ''}>${text}</a>`;
};

marked.setOptions({ breaks: true });

// Flag em memória (escopo de módulo): mantém o popup fechado durante a navegação SPA
// e reinicia apenas quando o usuário atualizar o navegador (F5 / reload).
let avisoPopupLoginFechado = false;

export default {
  name: 'login', // Nome do componente atual
  components: {
    // Componentes utilizados dentro deste componente
    Carousel, // Componente de carrossel global
    AvisosCarousel,
  },

  data() {
    let cached = null;
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) cached = JSON.parse(raw);
    } catch (e) {
      console.warn(e);
    }

    const cachedNumbers = cached && cached.numbers ? cached.numbers : null;
    const hasCachedLogo = !!(cachedNumbers && cachedNumbers.logoLogin);

    return {
      // Dados do componente
      anoAtual: new Date().getFullYear(), // Ano atual
      erro: null, // Armazenamento de erros
      aviso: null, // Armazenamento de avisos (warn)
      loading: false, // Indicador de carregamento
      currentUser: null, // Informações do usuário atual logado
      expired: null, // Informação sobre a expiração da sessão ou dados
      showEsqueceu: false, // Controle de visibilidade do modal "Esqueceu a Senha"
      login: new Login(), // Instância do modelo de login
      loginNovaSenha: null, // Instância do modelo de login
      manutencao: false, // Flag para indicar se o sistema está em manutenção
      numbers: cachedNumbers || {}, // Armazena números relacionados à NFSe (UI Otimista)
      idCliente: cached ? cached.idCliente : null, // ID do cliente
      idAutenticacao: null, // Tipo de autenticação retornado pelo backend (3: Certificado, 5: GOV, 6: Certificado + GOV, outro/inicial: Senha + Certificado)
      ultimoLoginConsultado: null,
      consultandoAutenticacao: false,
      configs: null,
      showCertificado: false, // Controle de visibilidade do modal de certificado digital
      showCarregarCert: false, // Controle de visibilidade durante o carregamento do certificado
      notaTomador: cached ? !!cached.notaTomador : false, // Controle de visibilidade de notas para tomador
      showDenunciaFiscal: cached ? !!cached.showDenunciaFiscal : false, // Controle de visibilidade do modal de denúncia fiscal
      loginMenssagemSimoes: null, // Mensagem personalizada relacionada ao login de Simões
      idSimoes: null, // ID relacionado ao cliente de Simões
      selectedTipoPessoa: null, // Tipo de pessoa selecionada (Física, Jurídica ou Entidade)
      tiposPessoa: [
        // Opções de tipos de pessoa para seleção
        { name: 'Pessoa Física', key: 'F' },
        { name: 'Pessoa Jurídica', key: 'J' },
        { name: 'Entidade', key: 'E' },
      ],
      apresentacao: false, // Controle de exibição da apresentação
      linkRequestCert: '', // Link para requisição de certificado
      siteKey: '6LfvEi4gAAAAAMbyRV0UO2i8ovyoQkNs0suhoMc5', // Chave do reCAPTCHA utilizada na validação
      recaptchaVerified: false, // Status de verificação do reCAPTCHA
      showCaptcha: false, // Controle de visibilidade do modal do reCAPTCHA
      exibirLogo: hasCachedLogo, // Controle para exibição imediata do logo no login
      logoLogin: hasCachedLogo ? 'data:image/jpg;base64,' + cachedNumbers.logoLogin : '', // Logo em base64 imediato
      carouselButtons: [],
      AvisosCarousel: [],
      showLinkRps: false,
      msgContatoLogin: cachedNumbers ? cachedNumbers.msgContatoLogin || null : null,
      showDadosCliente: !!(cachedNumbers && cachedNumbers.msgContatoLogin),
      showTutoriaisDialog: false,
      showVideoDialog: false,
      videoAtual: null,
      avisoPopupLogin: null,
      showAvisoPopupLogin: false,
      sistemaBloqueado: cached ? !!cached.sistemaBloqueado : false,
      tutoriais: [
        {
          titulo: 'Tutorial 1 - Credenciamento no Nota Fiscal',
          descricao: 'Aprenda como realizar seu cadastro inicial para começar a emitir notas fiscais.',
          duracao: '~1 min',
          url: 'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Credenciamento+NFS-e+-+V%C3%ADdeo+Final.mp4',
        },
        {
          titulo: 'Tutorial 2 - Vinculando Acessos ao Nota Fiscal',
          descricao: 'Veja como vincular usuários e definir os acessos corretos no sistema de NFS-e.',
          duracao: '~1 min',
          url:
            'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Vinculando+Acessos+NFS-e+-+V%C3%ADdeo+Final.mp4',
        },
        {
          titulo: 'Tutorial 3 - Lançamento de Nota Fiscal',
          descricao: 'Passo a passo para emitir sua primeira Nota Fiscal de Serviço Eletrônica.',
          duracao: '~7 min',
          url:
            'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Lan%C3%A7amento+Nota+Fiscal+-+V%C3%ADdeo+Final.mp4',
        },
        {
          titulo: 'Tutorial 4 - Cancelamento de Nota Fiscal',
          descricao: 'Saiba como cancelar uma nota fiscal já emitida de forma correta.',
          duracao: '~3 min',
          url: 'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Cancelar+Nota+Fiscal+-+V%C3%ADdeo+Final.mp4',
        },
        {
          titulo: 'Tutorial 5 - Declaração de Nota Fiscal',
          descricao: 'Entenda como realizar a declaração de serviços prestados no sistema.',
          duracao: '~2 min',
          url:
            'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Declara%C3%A7%C3%A3o+NFS-e+-+V%C3%ADdeo+Final+-+Op%C3%A7%C3%A3o+2.mp4',
        },
        {
          titulo: 'Tutorial 6 - Cancelar Declaração de Nota Fiscal',
          descricao: 'Aprenda como cancelar uma declaração de serviços já realizada no sistema.',
          duracao: '~2 min',
          url:
            'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Videos/Cancelar+Declara%C3%A7%C3%A3o+Nota+Fiscal+-+V%C3%ADdeo+Final.mp4',
        },
      ],
      abaTutorialSelecionada: 'videos',
      abaApiSelecionada: 'dps',
      // URLs de Documentação Técnica da Nota Nacional (Modelo DPS)
      urlDocDpsProducao: 'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Layout_EL_DPS_Nacional.zip',
      // Documentação técnica de Homologação com XSD oficial inicial da NT 009 (Release 1)
      urlDocDpsHomologacao: 'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/Layout_2026_NT009_1.zip',
      documentosTutoriais: [
        {
          titulo: 'POP - Emissão de Documentos Auxiliares de Prestação de Serviço (DAPS)',
          descricao:
            'Procedimento Operacional Padrão com o passo a passo completo para emissão de DAPS no sistema de NFS-e.',
          url:
            'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/tutorial/POP+-+Nota+Fiscal+-+Emissao+De+Documentos+Auxiliares+De+Prestacao+De+Servico+(DAPS).pdf',
          nomeDownload: 'POP - Nota Fiscal - Emissao De Documentos Auxiliares De Prestacao De Servico (DAPS).pdf',
          formato: 'PDF',
          tamanho: '215 KB',
          categoria: 'Emissão DAPS',
        },
        {
          titulo: 'POP - Consulta de DAPS',
          descricao:
            'Procedimento Operacional Padrão detalhado para consulta, acompanhamento e visualização de DAPS emitidas.',
          url: 'https://s3.us-east-1.amazonaws.com/el.com.br/nfse/tutorial/POP+-+Nota+Fiscal+-+Consulta+DAPS.pdf',
          nomeDownload: 'POP - Nota Fiscal - Consulta DAPS.pdf',
          formato: 'PDF',
          tamanho: '213 KB',
          categoria: 'Consulta DAPS',
        },
      ],
      assistidos: JSON.parse(localStorage.getItem('nfse_tutoriais_assistidos') || '[]'),
    };
  },

  // Hook "created" (executado quando o componente é criado)
  created() {
    // Inicializa os dados da apresentação (caso exista a propriedade '$apresentacao', utiliza-a; caso contrário, define como 'false')
    this.apresentacao = this.$apresentacao ? this.$apresentacao : false;

    // Define o tipo de pessoa selecionado como o primeiro item da lista de tipos de pessoa
    this.selectedTipoPessoa = this.tiposPessoa[0];

    // UI Otimista: restaura imediatamente do cache se já visitado
    this.restaurarCacheLogin();
  },

  // Definição dos validadores para os campos de login e senha
  validators: {
    // Validador para o campo "login.nomeAcesso"
    'login.nomeAcesso': function(value) {
      return (
        Validator.value(value)
          // Verifica se o campo "Login" está preenchido
          .required('Campo Login Obrigatório')
          // Verifica se o tamanho do login não ultrapassa 200 caracteres
          .maxLength(200, 'Login deve ser menor ou igual a 200')
      );
    },

    // Validador para o campo "login.senhaAcesso"
    'login.senhaAcesso': function(value) {
      if (!this.exibirCampoSenha) {
        return null;
      }
      return (
        Validator.value(value)
          // Verifica se o campo "Senha" está preenchido
          .required('Campo Senha Obrigatório')
          // Verifica se o tamanho da senha não ultrapassa 50 caracteres
          .maxLength(50, 'Senha deve ser menor ou igual a 50')
      );
    },
  },

  // Hook "mounted" (executado quando o componente é montado)
  mounted() {
    this.currentIndex = 0; // Garantir que o carrossel comece do início
    var d = new Date(); // Configuração inicial
    this.anoAtual = d.getFullYear(); // Armazena o ano atual

    if (this.$route.query.manutencao && this.$route.query.manutencao == 'N') {
      this.manutencao = false;
    } else {
      this.$nextTick(() => {
        const el = document.getElementById('usuario');
        if (el) el.focus();
      });
    }

    if (this.$route.query.recover === 'true') {
      this.showEsqueceu = true;
      if (this.$route.query.doc) {
        this.loginNovaSenha = this.$route.query.doc;
      }
      if (this.$route.query.type) {
        const foundType = this.tiposPessoa.find((t) => t.key === this.$route.query.type);
        if (foundType) {
          this.selectedTipoPessoa = foundType;
        }
      }
    }

    if (this.$route.query.erroGov) {
      this.erro = 'Não foi possível autenticar pelo GOV.BR: ' + this.$route.query.erroGov;
      this.$root.$emit('alert:error', this.erro);
    }

    this.carregarDadosLogin();
  },

  // Hook "beforeDestroy" (executado antes do componente ser destruído)
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); // Remove o listener do evento de redimensionamento
  },

  methods: {
    // Restaura dados do cache para UI OTIMISTA instantânea (zero delay/flicker)
    restaurarCacheLogin() {
      try {
        const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
        if (raw) {
          const data = JSON.parse(raw);
          if (data && data.numbers) {
            this.numbers = data.numbers;
            this.idCliente = data.idCliente || this.idCliente;
            this.sistemaBloqueado = !!data.sistemaBloqueado;
            this.showDenunciaFiscal = !!data.showDenunciaFiscal;
            this.notaTomador = !!data.notaTomador;
            this.msgContatoLogin = data.numbers.msgContatoLogin || '';
            this.showDadosCliente = !!data.numbers.msgContatoLogin;
            if (data.numbers.logoLogin) {
              this.exibirLogo = true;
              this.logoLogin = 'data:image/jpg;base64,' + data.numbers.logoLogin;
            }
            this.atualizarSEO(this.numbers);
          }
        }
      } catch (e) {
        console.warn('Erro ao restaurar cache otimista de login', e);
      }
      this.carouselButtons = this.carregarLinks();
    },

    // Carrega dados de login e atualiza cache em segundo plano (stale-while-revalidate)
    async carregarDadosLogin() {
      try {
        let host = window.location.hostname;
        this.dnsCliente = await DnsClienteService.get(host);
        this.expired = this.$route.query.expired;

        if (this.dnsCliente && this.dnsCliente.data && this.dnsCliente.data.idCliente) {
          this.idCliente = this.dnsCliente.data.idCliente;
          this.sistemaBloqueado = false;
          if (this.dnsCliente.data.idBolBloquearSistema && this.dnsCliente.data.idBolBloquearSistema === 'S') {
            this.sistemaBloqueado = true;
          }
          this.showDenunciaFiscal = this.apresentacao;

          if ('19533831040781681800D2584C905F8A' === this.idCliente) {
            this.notaTomador = true;
          } else if ('ce744068-cc92-479f-bf9d-d88cf4238517' === this.idCliente) {
            this.showDenunciaFiscal = true;
          }

          this.idSimoes = this.dnsCliente.data.idCliente;

          this.carregarAvisoPopupLogin(this.idCliente);

          const res = await Numero.listarNumeros(this.dnsCliente.data.idCliente);
          this.numbers = res.data;
          this.atualizarSEO(this.numbers);
          this.carouselButtons = this.carregarLinks();
          this.msgContatoLogin = this.numbers.msgContatoLogin;
          if (res.data.logoLogin) {
            this.exibirLogo = true;
            this.logoLogin = 'data:image/jpg;base64,' + res.data.logoLogin;
          }
          this.showDadosCliente = !!this.numbers.msgContatoLogin;

          // Salva em cache para UI OTIMISTA imediata nas próximas visitas (localStorage + sessionStorage)
          const cacheData = JSON.stringify({
            numbers: this.numbers,
            idCliente: this.idCliente,
            sistemaBloqueado: this.sistemaBloqueado,
            showDenunciaFiscal: this.showDenunciaFiscal,
            notaTomador: this.notaTomador,
          });
          try {
            localStorage.setItem('nfse_login_cache', cacheData);
            sessionStorage.setItem('nfse_login_cache', cacheData);
          } catch (e) {
            console.warn(e);
          }
        }
      } catch (err) {
        console.error('Erro ao carregar dados do login:', err);
      }
    },

    // Atualiza dinamicamente os metadados SEO da página com os dados do município
    atualizarSEO(numbers) {
      const nome = (numbers.nomeEntidade || numbers.nomeCliente || '').trim();
      if (!nome) return;

      // Extrai UF e município do hostname: ex. "mg-almenara-pm-nfs.cloud.el.com.br"
      const partes = window.location.hostname.split('-');
      const uf = partes.length >= 2 ? partes[0].toUpperCase() : '';

      const titulo = `NFS-e ${nome}${uf ? ' ' + uf : ''} - Nota Fiscal de Serviço Eletrônica`;
      const descricao = `Emita e consulte sua Nota Fiscal de Serviço Eletrônica (NFS-e) em ${nome}${
        uf ? ', ' + uf : ''
      }. Sistema oficial da Prefeitura Municipal.`;
      const url = window.location.origin;

      // Atualiza title
      document.title = titulo;

      // Atualiza ou cria meta description
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', descricao);

      // Atualiza keywords
      let metaKeys = document.querySelector('meta[name="keywords"]');
      if (metaKeys) {
        const nomeLower = nome.toLowerCase();
        const ufLower = uf.toLowerCase();
        metaKeys.setAttribute(
          'content',
          `nfs ${nomeLower}, nota fiscal ${nomeLower}, nfse ${nomeLower} ${ufLower}, prefeitura ${nomeLower} nota fiscal, nota fiscal de serviço ${nomeLower}`,
        );
      }

      // Atualiza Open Graph
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', titulo);
      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', descricao);

      // Atualiza/cria og:url
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (!ogUrl) {
        ogUrl = document.createElement('meta');
        ogUrl.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrl);
      }
      ogUrl.setAttribute('content', url);

      // Atualiza link canonical
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);

      // Atualiza JSON-LD com dados do município
      const jsonLd = document.getElementById('jsonld-organization');
      if (jsonLd) {
        jsonLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'GovernmentService',
          name: titulo,
          description: descricao,
          url: url,
          provider: {
            '@type': 'GovernmentOrganization',
            name: nome,
          },
          developer: {
            '@type': 'Organization',
            name: 'EL Produções de Software',
            url: 'https://www.el.com.br',
            foundingDate: '1993',
            foundingLocation: 'Domingos Martins, ES, Brasil',
            description:
              'Empresa especializada em soluções de Tecnologia da Informação e Comunicação para gestão pública, com 32 anos de mercado e clientes em ES, RJ, MG, BA, PE e SP.',
            areaServed: ['ES', 'RJ', 'MG', 'BA', 'PE', 'SP'],
            telephone: '+55-27-3268-3123',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Rua João Batista Wernersbach, Nº 67, Centro',
              addressLocality: 'Domingos Martins',
              addressRegion: 'ES',
              postalCode: '29260-000',
              addressCountry: 'BR',
            },
            sameAs: [
              'https://www.linkedin.com/company/elsoftware/',
              'https://www.instagram.com/el.com.br',
              'https://www.youtube.com/elproducoesdesoftware',
            ],
          },
          areaServed: {
            '@type': 'City',
            name: nome,
          },
          serviceType: 'Nota Fiscal de Serviço Eletrônica',
        });
      }
    },

    renderMarkdown(text) {
      if (!text) return '';
      const raw = text
        .replace(/\\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
      return marked.parse(raw, { breaks: true, renderer });
    },

    handleSuccess(response) {
      // Método para lidar com o sucesso da verificação do reCAPTCHA
      console.log('reCaptcha verificado: ', response); // Loga a resposta da verificação do reCAPTCHA

      setTimeout(() => {
        // Aguarda 800 milissegundos antes de executar a lógica a seguir
        this.recaptchaVerified = true; // Marca o reCAPTCHA como verificado
        this.loginUser(); // Chama o método para realizar o login do usuário
        this.recaptchaVerified = false; // Reseta a verificação do reCAPTCHA após o login
        this.showCaptcha = false; // Esconde o modal do Captcha
      }, 800);
    },

    showJanelaCertificado() {
      // Método para mostrar janela de certificado
      this.showCertificado = true; // Define a variável que controla a exibição da janela de certificado como verdadeira
      this.showCarregarCert = false; // Esconde o indicador de carregamento do certificado
    },

    hideJanelaCertificado() {
      // Método para esconder a janela de certificado
      this.showCertificado = false; // Define a variável que controla a exibição da janela de certificado como falsa
      this.showCarregarCert = false; // Esconde o indicador de carregamento do certificado
    },

    carregarCertificado() {
      // Método para carregar certificado
      this.showCarregarCert = true; // Exibe o indicador de carregamento do certificado
      let currentUrl = window.location; // Obtém a URL atual da janela
      let api_url = this.$configAppData ? this.$configAppData.baseUrl : ''; // Define a URL da API base, se disponível
      this.linkRequestCert = 'https://certificado.cloud.el.com.br/gpilogin/base64NF'; // Define o link para requisitar o certificado
      this.linkRequestCert = this.linkRequestCert + '?urlRetorno=' + api_url + '/requestCertificado'; // Adiciona a URL de retorno à solicitação do certificado
      this.linkRequestCert = this.linkRequestCert + '&urlFront=' + currentUrl; // Adiciona a URL frontal à solicitação do certificado
      window.open(this.linkRequestCert, '_self', ''); // Abre o link de solicitação do certificado na mesma janela
      return false; // Retorna falso para evitar qualquer outro comportamento padrão
    },

    iniciarLoginGov() {
      // Método para iniciar autenticação com o GOV.BR
      this.removerErro();
      this.processando(true);

      GovService.iniciarLoginGov(this.idCliente, false)
        .then((response) => {
          if (response && response.data && response.data.urlChamadaGovbr) {
            window.location.href = response.data.urlChamadaGovbr;
          } else {
            this.processando(false);
            this.erro = 'Não foi possível obter a URL de autenticação do GOV.BR.';
            this.$root.$emit('alert:error', this.erro);
          }
        })
        .catch((error) => {
          this.processando(false);
          console.error('Erro ao iniciar login com GOV.BR:', error);
          const mensagem =
            (error.response && error.response.data && (error.response.data.message || error.response.data)) ||
            'Não foi possível conectar ao serviço do GOV.BR. Tente novamente mais tarde.';
          this.erro = typeof mensagem === 'string' ? mensagem : 'Erro ao conectar com o serviço do GOV.BR.';
          this.$root.$emit('alert:error', this.erro);
        });
    },

    removerErro() {
      // Método para remover erro
      this.erro = null; // Limpa a variável de erro, definindo-a como nula
      this.aviso = null; // Limpa a variável de aviso
    },

    onInputLogin() {
      this.removerErro();
      const login = this.login && this.login.nomeAcesso ? this.login.nomeAcesso.trim() : '';
      if (!login) {
        this.idAutenticacao = null;
        this.ultimoLoginConsultado = null;
      } else if (this.ultimoLoginConsultado && this.ultimoLoginConsultado !== login) {
        this.ultimoLoginConsultado = null;
      }
    },

    async consultarTipoAutenticacao() {
      const login = this.login && this.login.nomeAcesso ? this.login.nomeAcesso.trim() : '';
      if (!login) {
        this.idAutenticacao = null;
        this.ultimoLoginConsultado = null;
        return;
      }

      if (this.ultimoLoginConsultado === login) {
        return;
      }

      const idCliente =
        this.idCliente || (this.dnsCliente && this.dnsCliente.data ? this.dnsCliente.data.idCliente : null);
      if (!idCliente) {
        return;
      }

      this.consultandoAutenticacao = true;
      try {
        const response = await LoginService.obterUsuarioLogin(login, idCliente);
        this.ultimoLoginConsultado = login;
        if (response && response.data && response.data.idAutenticacao != null) {
          this.idAutenticacao = Number(response.data.idAutenticacao);
        } else {
          this.idAutenticacao = null;
        }
      } catch (error) {
        // Se usuário não for encontrado ou ocorrer erro, mantém exibição padrão (condição 4)
        this.ultimoLoginConsultado = login;
        this.idAutenticacao = null;
      } finally {
        this.consultandoAutenticacao = false;
      }
    },

    handleLogin() {
      // Método para lidar com o login
      if (!this.exibirCampoSenha) {
        if (this.idAutenticacao === 3) {
          this.showJanelaCertificado();
        } else if (this.idAutenticacao === 5) {
          this.iniciarLoginGov();
        }
        return;
      }

      this.$validate().then((success) => {
        // Se não estiver em modo de apresentação, valida os campos do formulário
        if (success) {
          // Se a validação for bem-sucedida
          this.processando(true); // Indica que o processamento está em andamento
          this.loginUser(); // Realiza o login do usuário
          this.processando(false); // Indica que o processamento foi concluído
        }
      });
    },

    loginUser() {
      // Método para realizar o login do usuário
      /*desabilitado (if (this.apresentacao) {                                                                           // Verifica se está em modo de apresentação
        this.showCaptcha = true;                                                                         // Exibe o modal do reCAPTCHA
        if (this.recaptchaVerified) {                                                                    // Verifica se o reCAPTCHA foi verificado
          LoginService.login(this.login, this.idCliente).then(                                           // Chama o serviço de login, passando as informações de login e o ID do cliente
            (data) => {
              //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
              console.log(data); // Exibe os dados retornados (para fins de depuração)
              if (LoginService.currentUserValue && LoginService.currentUserValue.homePage) {             // Verifica se o usuário atual possui uma página inicial definid
                const homePage = LoginService.currentUserValue.homePage;
                this.$router.push(homePage);                                                             // Redireciona para a página inicial do usuário
              } else {
                this.erro = "Login ou Senha inválidos!";                                                 // Define uma mensagem de erro caso o login ou a senha estejam inválidos
              }
            },
            (error) => {                                                                                 // Exibe o erro retornado (para fins de depuração)
              console.log(error);
              this.erro = "Login ou Senha inválidos!";                                                   // Define uma mensagem de erro caso ocorra um erro durante o login
            }
          );
        }
      } else {*/
      LoginService.login(this.login, this.idCliente).then(
        // Chama o serviço de login, passando as informações de login e o ID do cliente
        (data) => {
          //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
          if (LoginService.currentUserValue && LoginService.currentUserValue.homePage) {
            // Verifica se o usuário atual possui uma página inicial definida
            console.log(data); // Exibe os dados retornados (para fins de depuração)
            const homePage = LoginService.currentUserValue.homePage;
            localStorage.setItem('displayInformacao', null);
            this.$router.push(homePage); // Redireciona para a página inicial do usuário
          } else {
            this.erro = 'Login ou Senha inválidos!'; // Define uma mensagem de erro caso o login ou a senha estejam inválidos
            this.aviso = null;
          }
        },
        (error) => {
          // Exibe o erro retornado (para fins de depuração)
          console.log(error);
          if (error && error.response && error.response.data) {
            const data = error.response.data;
            const msg = typeof data === 'string' ? data : (data.msg || data.message || '');
            if (msg.toLowerCase().includes('vigência') || msg.toLowerCase().includes('vigencia')) {
              this.aviso = msg;
              this.erro = null;
              return;
            }
          }
          this.erro = 'Login ou Senha inválidos!'; // Define uma mensagem de erro caso ocorra um erro durante o login
          this.aviso = null;
        },
      );
      //}
    },

    processando(show) {
      // Método para mostrar/esconder loading
      if (show) {
        this.loading = true; // Ativa o estado de loading
        this.$root.$emit('loading:show'); // Emite um evento para mostrar o loading globalmente
      } else {
        this.loading = false; // Desativa o estado de loading
        this.$root.$emit('loading:hide'); // Emite um evento para esconder o loading globalmente
      }
    },

    esqueceuSenha() {
      // Métodos relacionados à recuperação de senha
      this.limparDadosPessoa(); // Limpa os dados da pessoa antes de mostrar a tela de recuperação
      this.showEsqueceu = true; // Exibe a janela de recuperação de senha
    },

    hideNovaSenha() {
      this.loading = false; // Desativa o loading ao fechar a janela
      this.showEsqueceu = false; // Esconde a janela de recuperação de senha
    },

    limparDadosPessoa() {
      this.loginNovaSenha = null; // Limpa o campo de nova senha
    },

    requisitarNovaSenha() {
      if (!this.loginNovaSenha) {
        // Verifica se o campo de nova senha está vazio
        this.$root.$emit('alert:warn', 'Informe um Login válido!'); // Emite um alerta de aviso
      } else {
        this.loading = true; // Ativa o loading ao iniciar a requisição
        LoginService.recuperarSenha(this.loginNovaSenha, this.idCliente).then(
          // Chama o serviço para recuperação de senha
          (response) => {
            console.log(response); // Exibe a resposta no console (para fins de depuração)
            this.$root.$emit(
              // Emite um alerta de sucesso informando que o e-mail foi enviado
              'alert:success',
              'Foi enviado um e-mail para recuperação de Senha da sua conta!',
            );
          },
          (error) => {
            console.log(error); // Exibe o erro no console (para fins de depuração)
            this.loading = false; // Desativa o loading em caso de erro
            this.$root.$emit('alert:warn', error.response.data); // Emite um alerta de aviso com a mensagem de erro
          },
        );
      }
    },

    formataValorReal(valor) {
      // Método para formatar valor em Real
      if (typeof valor !== 'number' || isNaN(valor)) {
        // Verifica se o valor é válido e é um número
        return ''; // Retorna uma string vazia se o valor não for um número válido
      }

      const formatter = new Intl.NumberFormat('pt-BR', {
        // Formatando o valor para moeda brasileira (BRL)
        style: 'currency', // Define o estilo como moeda
        currency: 'BRL', // Define a moeda como Real brasileiro
      });

      return formatter.format(valor); // Retorna o valor formatado
    },

    // Métodos de ação para os botões
    autenticar() {
      this.$router.push('/autenticacao');
    },
    retencao() {
      this.$router.push('/reciboRetencao');
    },
    credenciar() {
      this.$router.push('/credenciamento');
    },
    abrirLinkRps() {
      if (this.idCliente) {
        LoginService.carregarConfiguracoesLinkRps(this.idCliente).then(
          (response) => {
            this.configs = response.data;
            console.log('here', this.configs);
            if (this.numbers && (this.numbers.linkProducaoRestrita || this.numbers.linkProducao)) {
              this.abaApiSelecionada = 'dps';
            } else {
              this.abaApiSelecionada = 'abrasf';
            }
            this.showLinkRps = true;
          },
          (error) => {
            console.log(error); // Exibe o erro no console (para fins de depuração)
            this.loading = false; // Desativa o loading em caso de erro
            this.$root.$emit('alert:warn', error.response.data); // Emite um alerta de aviso com a mensagem de erro
          },
        );
      } else {
        if (this.numbers && (this.numbers.linkProducaoRestrita || this.numbers.linkProducao)) {
          this.abaApiSelecionada = 'dps';
        } else {
          this.abaApiSelecionada = 'abrasf';
        }
        this.showLinkRps = true;
      }
    },
    contribuintes() {
      this.$router.push('/contribuintes');
    },
    consultarRps() {
      this.$router.push('/consultaRps');
    },
    denunciaFiscal() {
      this.$router.push('/denunciaFiscal');
    },
    dadosContato() {
      this.openDialogMsgContato = true;
    },
    copiarLinkRps() {
      navigator.clipboard.writeText(this.numbers.linkRps);
      this.$root.$emit('alert:success', 'Link RPS copiado para a área de transferência!');
    },
    copiarLinkProducaoRestrita() {
      navigator.clipboard.writeText(this.numbers.linkProducaoRestrita);
      this.$root.$emit('alert:success', 'Link Nota Nacional de Homologação copiado para a área de transferência!');
    },
    copiarLinkProducao() {
      navigator.clipboard.writeText(this.numbers.linkProducao);
      this.$root.$emit('alert:success', 'Link Nota Nacional de Produção copiado para a área de transferência!');
    },

    assistirVideo(video) {
      this.videoAtual = video;
      this.showTutoriaisDialog = false;
      this.showVideoDialog = true;
      if (!this.assistidos.includes(video.url)) {
        this.assistidos.push(video.url);
        localStorage.setItem('nfse_tutoriais_assistidos', JSON.stringify(this.assistidos));
      }
    },

    jaAssistido(video) {
      return this.assistidos.includes(video.url);
    },

    fecharVideo() {
      this.showVideoDialog = false;
      this.videoAtual = null;
      this.showTutoriaisDialog = true;
    },

    baixarTutoriais() {
      const a = document.createElement('a');
      a.href = this.numbers.linkTutoriais;
      a.click();
    },

    abrirDocumento(doc) {
      if (doc && doc.url) {
        window.open(doc.url, '_blank');
      }
    },

    baixarDocumento(doc) {
      if (!doc || !doc.url) return;
      const a = document.createElement('a');
      a.href = doc.url;
      a.target = '_blank';
      a.download = doc.nomeDownload || 'documento.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    carregarLinks() {
      let retorno = [];
      if (this.sistemaBloqueado) {
        return;
      }
      retorno.push({
        text: 'Acesso aos tutoriais',
        icon: require('@/assets/icons/icon-consultar.svg'),
        alt: 'Ícone Tutoriais',
        action: () => {
          this.showTutoriaisDialog = true;
        },
        route: null,
      });
      retorno.push({
        text: 'Clique aqui para se Credenciar',
        icon: require('@/assets/icons/icon-credencial.svg'),
        alt: 'Ícone credencial',
        action: this.credenciar,
        route: '/credenciamento',
      });
      retorno.push({
        text: 'Clique aqui para autenticar Documento',
        icon: require('@/assets/icons/icon-doc.svg'),
        alt: 'Ícone autenticar documento',
        action: this.autenticar, // Ação ao clicar no botão
        route: '/autenticacao', // Rota para onde o botão leva
      });
      retorno.push({
        text: 'Clique aqui para Recibo de Retenção',
        icon: require('@/assets/icons/icon-recibo-carousel.svg'),
        alt: 'Ícone recibo de retenção',
        action: this.retencao,
        route: '/reciboRetencao',
      });
      if (this.numbers && this.numbers.linkRps) {
        retorno.push({
          text: 'APIs de Integração',
          icon: require('@/assets/icons/icon-link.svg'),
          alt: 'Ícone APIs de Integração',
          action: this.abrirLinkRps,
          route: null,
        });
      }
      retorno.push({
        text: 'Clique para consultar RPS convertido em NFS-e.',
        icon: require('@/assets/icons/icon-consultar.svg'),
        alt: 'Ícone consultar',
        action: this.consultarRps,
        route: '/consultaRps',
      });
      if (this.apresentacao || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        retorno.push({
          text: 'Listagem de Contribuintes',
          icon: require('@/assets/icons/icon-listagem.svg'),
          alt: 'Ícone listagem',
          action: this.contribuintes,
          route: '/contribuintes',
        });
      }
      if (this.showDenunciaFiscal || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        retorno.push({
          text: 'Realize uma Denúncia relacionada à Prestação de Serviços.',
          icon: require('@/assets/icons/icon-denuncia.svg'),
          alt: 'Ícone denuncia',
          action: this.denunciaFiscal,
          route: '/denunciaFiscal',
        });
      }
      return retorno;
    },

    hideJanelaSenha() {
      // Método para esconder a janela de senha
      this.showEsqueceu = false; // Define a variável que controla a exibição da janela de senha como falsa
      this.loading = false; // Esconde o indicador de loading
    },

    parseDataAviso(valor, fimDoDia = false) {
      if (!valor) return null;
      if (typeof valor === 'string') {
        const limpo = valor.trim().split('T')[0].split(' ')[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(limpo)) {
          const [ano, mes, dia] = limpo.split('-').map(Number);
          return fimDoDia
            ? new Date(ano, mes - 1, dia, 23, 59, 59, 999)
            : new Date(ano, mes - 1, dia, 0, 0, 0, 0);
        }
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(limpo)) {
          const [dia, mes, ano] = limpo.split('/').map(Number);
          return fimDoDia
            ? new Date(ano, mes - 1, dia, 23, 59, 59, 999)
            : new Date(ano, mes - 1, dia, 0, 0, 0, 0);
        }
      }
      const d = new Date(valor);
      if (isNaN(d.getTime())) return null;
      return fimDoDia
        ? new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999)
        : new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    },

    isAvisoVigente(aviso) {
      if (!aviso) return false;
      if (aviso.statusAtividade && aviso.statusAtividade !== 'A') return false;

      const agora = new Date();
      const dtIni = this.parseDataAviso(
        aviso.dataVigenciaInicial || aviso.dataVigenciaInicialFormatada,
        false
      );
      if (dtIni && agora < dtIni) return false;

      const dtFim = this.parseDataAviso(
        aviso.dataVigenciaFinal || aviso.dataVigenciaFinalFormatada,
        true
      );
      if (dtFim && agora > dtFim) return false;

      return true;
    },

    possuiConteudoMensagemPopup(aviso) {
      if (!aviso || !aviso.mensagem) return false;
      const textoSemTags = aviso.mensagem.replace(/<[^>]*>/g, '').trim();
      const contemImg = /<img\b/i.test(aviso.mensagem);
      return Boolean(textoSemTags || contemImg);
    },

    selecionarUltimoAvisoPopupVigente(listaAvisos) {
      if (!Array.isArray(listaAvisos) || !listaAvisos.length) return null;

      const vigentes = listaAvisos.filter(
        (aviso) =>
          aviso &&
          aviso.tipoEnvio === 'P' &&
          aviso.tipo === 'T' &&
          this.possuiConteudoMensagemPopup(aviso) &&
          this.isAvisoVigente(aviso)
      );

      if (!vigentes.length) return null;
      if (vigentes.length === 1) return vigentes[0];

      const comIndice = vigentes.map((item, idx) => ({ item, idx }));
      comIndice.sort((a, b) => {
        const dtCadA = this.parseDataAviso(
          a.item.dataCadastro || a.item.dhCadastro || a.item.dtCadastro,
          false
        );
        const dtCadB = this.parseDataAviso(
          b.item.dataCadastro || b.item.dhCadastro || b.item.dtCadastro,
          false
        );
        if (dtCadA && dtCadB && dtCadA.getTime() !== dtCadB.getTime()) {
          return dtCadA.getTime() - dtCadB.getTime();
        }

        const idNumA = Number(a.item.id);
        const idNumB = Number(b.item.id);
        if (!isNaN(idNumA) && !isNaN(idNumB) && idNumA !== idNumB) {
          return idNumA - idNumB;
        }

        const dtIniA = this.parseDataAviso(
          a.item.dataVigenciaInicial || a.item.dataVigenciaInicialFormatada,
          false
        );
        const dtIniB = this.parseDataAviso(
          b.item.dataVigenciaInicial || b.item.dataVigenciaInicialFormatada,
          false
        );
        if (dtIniA && dtIniB && dtIniA.getTime() !== dtIniB.getTime()) {
          return dtIniA.getTime() - dtIniB.getTime();
        }

        return a.idx - b.idx;
      });

      return comIndice[comIndice.length - 1].item;
    },

    async carregarAvisoPopupLogin(idCliente) {
      if (!idCliente || avisoPopupLoginFechado) return;
      try {
        const res = await LoginService.findAllAvisos(idCliente);
        const lista = res && Array.isArray(res.data) ? res.data : [];
        const selecionado = this.selecionarUltimoAvisoPopupVigente(lista);

        if (selecionado && !avisoPopupLoginFechado) {
          this.avisoPopupLogin = { ...selecionado };
          this.showAvisoPopupLogin = true;
        } else {
          this.avisoPopupLogin = null;
          this.showAvisoPopupLogin = false;
        }
      } catch (err) {
        console.warn('Erro ao carregar aviso popup do login:', err);
      }
    },

    fecharAvisoPopupLogin() {
      avisoPopupLoginFechado = true;
      this.showAvisoPopupLogin = false;
      this.$nextTick(() => {
        const el = document.getElementById('usuario');
        if (el) el.focus();
      });
    },

    onHideAvisoPopupLogin() {
      avisoPopupLoginFechado = true;
      this.$nextTick(() => {
        const el = document.getElementById('usuario');
        if (el) el.focus();
      });
    },

    onClickConteudoPopup(event) {
      if (!this.linkDestinoAvisoPopup || !event || !event.target) return;
      const img = event.target.closest('img');
      const anchor = event.target.closest('a');
      if (img && !anchor) {
        window.location.href = this.linkDestinoAvisoPopup;
      }
    },
  },

  computed: {
    mensagemErro() {
      // Propriedade computada para gerar mensagens de erro baseadas no código de erro recebido na rota
      let codigoErro = this.$route.query.erro; // Obtém o código de erro da query da rota atual
      let msg = '';
      if (codigoErro) {
        // Verifica se um código de erro foi fornecido
        switch (
          codigoErro // Define a mensagem de erro com base no código de erro
        ) {
          case '1':
            msg = 'Autenticador Certisign não disponivel para realizar o Login.'; // Mensagem para erro 1
            break;
          case '2':
            msg = 'Não foi possível validar o certificado digital.'; // Mensagem para erro 2
            break;
          case '3':
            msg = 'Chave de criptografia do certificado inválida.'; // Mensagem para erro 3
            break;
          case '4':
            msg = 'Período de validade do certificado digital expirado.'; // Mensagem para erro 4
            break;
          case '5':
            msg = 'Não foi posssível obter a data de validade do certificado.'; // Mensagem para erro 5
            break;
          case '6':
            msg = 'Usuário não encontrado com documento relacionado ao certificado.'; // Mensagem para erro 6
            break;
          case '7':
            msg = 'Não foi possível validar o certificado digital.'; // Mensagem para erro 7
            break;
        }
        return msg; // Retorna a mensagem de erro correspondente
      } else {
        return null; // Se não houver código de erro, retorna null
      }
    },

    exibirCampoSenha() {
      // 1) idAutenticacao === 3: esconder campo senha
      // 2) idAutenticacao === 5: esconder campo senha
      // 3) idAutenticacao === 6: esconder campo senha
      // 4) diferente de 6, 5 e 3 (inclusive carga inicial null): exibir campo senha
      return this.idAutenticacao !== 3 && this.idAutenticacao !== 5 && this.idAutenticacao !== 6;
    },

    exibirBotaoCertificado() {
      // 1) idAutenticacao === 3: habilitar apenas certificado -> VISÍVEL
      // 2) idAutenticacao === 5: esconder certificado (apenas GOV) -> ESCONDIDO
      // 3) idAutenticacao === 6: habilitar certificado e GOV -> VISÍVEL
      // 4) diferente de 6, 5 e 3 (inclusive carga inicial null): padrão com certificado -> VISÍVEL
      return this.idAutenticacao !== 5;
    },

    exibirBotaoGov() {
      // 1) idAutenticacao === 3: apenas certificado -> ESCONDIDO
      // 2) idAutenticacao === 5: apenas GOV -> VISÍVEL
      // 3) idAutenticacao === 6: certificado e GOV -> VISÍVEL
      // 4) diferente de 6, 5 e 3 (inclusive carga inicial null): padrão escondendo botão GOV -> ESCONDIDO
      return this.idAutenticacao === 5 || this.idAutenticacao === 6;
    },

    isAbrasfInativo() {
      return !!(this.configs && this.configs.idBolHabilitarDpsProducao === 'S');
    },

    linkDestinoAvisoPopup() {
      const av = this.avisoPopupLogin;
      if (av && av.mensagem) {
        const hrefMatch = av.mensagem.match(/href=["'](https?:\/\/[^"']+)["']/i);
        if (hrefMatch && hrefMatch[1]) {
          return hrefMatch[1];
        }
        const textoLimpo = av.mensagem.replace(/<[^>]*>/g, ' ').trim();
        const urlMatch = textoLimpo.match(/https?:\/\/[^\s<>"']+/i);
        if (urlMatch && urlMatch[0]) {
          return urlMatch[0];
        }
      }
      return null;
    },

    exibirMensagemHtmlPopup() {
      return this.possuiConteudoMensagemPopup(this.avisoPopupLogin);
    },
  },
};
</script>

<style src="@/assets/css/login.css"></style>

<style scoped>
/* Modal Aviso Popup na Tela de Login */
.comunicado-nacional-modal {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.comunicado-nacional-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.comunicado-nacional-header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color, #193155);
}

.comunicado-nacional-header-title i {
  font-size: 18px;
  color: #0263b0;
}

.comunicado-nacional-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  max-height: 72vh;
  overflow-y: auto;
}

.comunicado-nacional-html {
  width: 100%;
  font-size: 14.5px;
  color: #1e293b;
  line-height: 1.55;
  word-break: break-word;
}

.comunicado-nacional-html >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  display: block;
  margin: 0 auto;
}

.comunicado-nacional-html.has-link >>> img,
.comunicado-nacional-html >>> a img {
  cursor: pointer;
}

.comunicado-nacional-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
}

/* Container e Scroll */
.tutoriais-modal-container {
  padding: 4px;
}

.tutoriais-content-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 6px;
  margin-top: 10px;
}

/* Custom Scrollbar */
.tutoriais-content-scroll::-webkit-scrollbar {
  width: 6px;
}
.tutoriais-content-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.tutoriais-content-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.tutoriais-content-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Nav Pills */
.tutoriais-nav-pills {
  display: flex;
  gap: 8px;
  background: #f1f5f9;
  padding: 5px;
  border-radius: 10px;
  margin-top: 14px;
  margin-bottom: 14px;
  border: 1px solid #e2e8f0;
}

.tutoriais-nav-pill {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tutoriais-nav-pill:hover:not(.active) {
  background: rgba(255, 255, 255, 0.6);
  color: #1e293b;
}

.tutoriais-nav-pill.active {
  background: #ffffff;
  color: var(--primary-color, #193155);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
}

.tutoriais-count-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  background: #e2e8f0;
  color: #334155;
  transition: all 0.2s ease;
}

.tutoriais-nav-pill.active .tutoriais-count-badge {
  background: #e2eaf4;
  color: var(--primary-color, #193155);
}

/* Info Banner */
.tutoriais-info-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--primary-color, #193155);
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 14px;
  font-size: 13px;
  color: #334155;
}

.tutoriais-info-banner i {
  font-size: 18px;
  color: var(--primary-color, #193155);
  margin-top: 2px;
  flex-shrink: 0;
}

.tutoriais-info-banner strong {
  display: block;
  font-size: 13px;
  color: #0f172a;
  margin-bottom: 2px;
}

.tutoriais-info-banner p {
  margin: 0;
  color: #64748b;
  font-size: 12.5px;
  line-height: 1.4;
}

/* Cards List */
.tutoriais-cards-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Card Base */
.tutorial-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  gap: 16px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.tutorial-card:hover {
  border-color: #cbd9eb;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
  transform: translateY(-1px);
}

/* Media Box */
.tutorial-card-media {
  width: 52px;
  height: 52px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.video-media {
  background: #eef3f8;
  border: 1px solid #d3e0ef;
  color: var(--primary-color, #193155);
  position: relative;
}

.tutorial-step-badge {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: var(--primary-color, #193155);
  line-height: 1;
  margin-bottom: 2px;
}

.tutorial-play-icon {
  font-size: 18px;
  color: var(--primary-color, #193155);
}

.doc-media {
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #dc2626;
}

.tutorial-pdf-icon {
  font-size: 20px;
  color: #dc2626;
}

.tutorial-pdf-label {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #dc2626;
  margin-top: 2px;
}

/* Card Details */
.tutorial-card-details {
  flex: 1;
  min-width: 0;
}

.tutorial-card-topbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.tutorial-card-title {
  font-size: 14.5px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.tutorial-card-desc {
  font-size: 12.5px;
  color: #64748b;
  margin: 4px 0 6px 0;
  line-height: 1.4;
}

.tutorial-card-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: #94a3b8;
}

.meta-item i {
  font-size: 11px;
}

/* Status Tags */
.tutorial-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
}

.status-concluido {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.status-pendente {
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.status-doc {
  background: #eef3f8;
  color: var(--primary-color, #193155);
  border: 1px solid #d3e0ef;
}

/* Actions */
.tutorial-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.tutoriais-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background-color: var(--primary-color, #193155);
  color: #ffffff !important;
  border: none;
  border-radius: 6px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  height: 38px;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.tutoriais-btn-primary:hover {
  background-color: #0a2854;
  box-shadow: 0 2px 6px rgba(25, 49, 85, 0.3);
}

.tutoriais-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background-color: #ffffff;
  color: var(--primary-color, #193155) !important;
  border: 1.5px solid var(--primary-color, #193155);
  border-radius: 6px;
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  height: 38px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.tutoriais-btn-secondary:hover {
  background-color: #eef3f8;
  border-color: #0a2854;
  color: #0a2854 !important;
  box-shadow: 0 2px 6px rgba(25, 49, 85, 0.15);
}

/* Footer Download */
.tutoriais-download-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 16px;
  padding: 16px 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--primary-color, #193155);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.footer-download-info {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.footer-download-info i {
  font-size: 24px;
  color: var(--primary-color, #193155);
  background: #eef3f8;
  padding: 10px;
  border-radius: 8px;
  flex-shrink: 0;
}

/* =============================================
   ABAS E CARDS DE APIS DE INTEGRAÇÃO (MODAL)
   ============================================= */
.api-content-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 6px;
  margin-top: 6px;
}

/* Nav Pills para APIs */
.api-nav-pills {
  display: flex;
  gap: 12px;
  background: #f1f5f9;
  padding: 6px;
  border-radius: 12px;
  margin-top: 14px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
}

.api-nav-pill {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.api-nav-pill:hover:not(.active) {
  background: rgba(255, 255, 255, 0.65);
  transform: translateY(-1px);
}

.api-nav-pill.active {
  background: #ffffff;
  border-color: #cbd5e1;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);
}

.api-pill-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.api-pill-icon svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
  transition: all 0.2s ease;
}

.api-pill-icon.abrasf {
  background: #f0fdf4;
  color: #16a34a;
}

.api-pill-icon.abrasf.inativo {
  background: #fef2f2;
  color: #b91c1c;
}

.api-nav-pill.active .api-pill-icon.dps {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.api-nav-pill.active .api-pill-icon.abrasf {
  background: #16a34a;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.3);
}

.api-nav-pill.active .api-pill-icon.abrasf.inativo {
  background: #b91c1c;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(185, 28, 28, 0.3);
}

.api-pill-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.api-pill-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.api-pill-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.api-pill-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 12px;
  letter-spacing: 0.4px;
  flex-shrink: 0;
}

.api-pill-badge.novo {
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.api-pill-badge.ativo {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.api-pill-badge.inativo {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

/* Card Informativo / Guia */
.api-guide-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 22px;
  margin-bottom: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.api-guide-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.api-guide-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.api-guide-tag.dps {
  color: #2563eb;
}

.api-guide-tag.abrasf {
  color: #16a34a;
}

.api-guide-tag.abrasf.inativo {
  color: #b91c1c;
}

.api-badge-status-novo {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
}

.api-badge-status-ativo {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
}

.api-badge-status-inativo {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
}

.api-alert-inativo {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.api-alert-inativo i {
  font-size: 20px;
  color: #d97706;
  margin-top: 2px;
  flex-shrink: 0;
}

.api-alert-inativo strong {
  display: block;
  font-size: 13.5px;
  color: #92400e;
  margin-bottom: 3px;
}

.api-alert-inativo p {
  margin: 0;
  font-size: 13px;
  color: #b45309;
  line-height: 1.5;
}

.api-guide-title {
  margin: 0 0 8px 0;
  font-size: 16.5px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
}

.api-guide-desc {
  margin: 0;
  font-size: 13.5px;
  color: #475569;
  line-height: 1.6;
}

/* Títulos de Seção Internos */
.api-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  font-weight: 700;
  color: #1e293b;
  margin: 20px 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.api-section-title i {
  color: var(--primary-color, #193155);
  font-size: 15px;
}

/* Banner de Download do Pacote ZIP */
.api-download-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1.5px solid #cbd5e1;
  border-radius: 12px;
  padding: 16px 20px;
  text-decoration: none !important;
  transition: all 0.25s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.api-download-box:hover {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);
}

.api-download-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.api-download-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #ffffff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.api-download-icon-circle.abrasf {
  color: #16a34a;
}

.api-download-icon-circle.abrasf.inativo {
  color: #b91c1c;
}

.api-download-details {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.api-download-filename {
  display: flex;
  align-items: center;
  gap: 8px;
}

.api-download-filename strong {
  font-size: 15px;
  color: #0f172a;
}

.api-file-ext {
  background: #e2e8f0;
  color: #334155;
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.api-download-sub {
  font-size: 12.5px;
  color: #64748b;
  margin: 3px 0 0 0;
  line-height: 1.4;
}

.btn-download-action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--primary-color, #193155);
  color: #ffffff !important;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.api-download-box:hover .btn-download-action {
  background: #0a2854;
  box-shadow: 0 4px 12px rgba(10, 40, 84, 0.2);
}

/* Container de múltiplos pacotes de download */
.api-downloads-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Card de Pacote de Download por Ambiente */
.api-download-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
}

.api-download-card.homologacao {
  border-left: 4px solid #f59e0b;
  background: linear-gradient(180deg, #fffdf8 0%, #ffffff 100%);
}

.api-download-card.producao {
  border-left: 4px solid #16a34a;
  background: linear-gradient(180deg, #fafffa 0%, #ffffff 100%);
}

.api-download-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: #cbd5e1;
}

.api-download-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.api-download-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* Badge de Destaque: XSD NT 009 Versão Inicial */
.api-badge-xsd-inicial {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.4px;
  padding: 3px 9px;
  border-radius: 6px;
  background: #fff7ed;
  color: #c2410c;
  border: 1.5px solid #fed7aa;
}

.api-badge-xsd-inicial i {
  font-size: 12px;
  color: #ea580c;
}

/* Badge de Destaque: XSD NÃO OFICIAL (Legado) */
.api-badge-xsd-nao-oficial {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.4px;
  padding: 3px 9px;
  border-radius: 6px;
  background: #fef2f2;
  color: #dc2626;
  border: 1.5px solid #fecaca;
  animation: pulseWarning 3s infinite ease-in-out;
}

@keyframes pulseWarning {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.2);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.15);
  }
}

.api-badge-xsd-nao-oficial i {
  font-size: 12px;
  color: #dc2626;
}

/* Badge de XSD Oficial */
.api-badge-xsd-oficial {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 3px 9px;
  border-radius: 6px;
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.api-badge-xsd-oficial i {
  font-size: 12px;
  color: #15803d;
}

/* Alerta Informativo Enfático sobre a NT 009 (Versão Inicial Oficial) */
.api-notice-nt009 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.api-notice-nt009-icon i {
  font-size: 20px;
  color: #d97706;
  margin-top: 2px;
  flex-shrink: 0;
}

.api-notice-nt009-body {
  flex: 1;
}

.api-notice-nt009-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.api-notice-nt009-header strong {
  font-size: 13px;
  font-weight: 700;
  color: #92400e;
}

.api-notice-pill {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
  padding: 2px 7px;
  border-radius: 4px;
}

.api-notice-nt009 p {
  margin: 0 0 6px 0;
  font-size: 12px;
  color: #78350f;
  line-height: 1.45;
}

.api-notice-points {
  margin: 6px 0 10px 0;
  padding-left: 18px;
  font-size: 12px;
  color: #78350f;
  line-height: 1.5;
}

.api-notice-points li {
  margin-bottom: 4px;
}

.api-notice-points li strong {
  color: #92400e;
}

.api-notice-points u {
  text-decoration-thickness: 1.5px;
  text-underline-offset: 2px;
}

.api-notice-footer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #fde68a;
}

.api-link-noticia-oficial {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #b45309;
  text-decoration: underline;
  transition: color 0.15s ease-in-out;
}

.api-link-noticia-oficial:hover {
  color: #78350f;
  text-decoration: underline;
}

.api-link-noticia-oficial i {
  font-size: 11px;
}

/* Alerta Informativo Enfático sobre XSD Não Oficial */
.api-notice-nao-oficial {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 12px;
}

.api-notice-nao-oficial i {
  font-size: 18px;
  color: #d97706;
  margin-top: 2px;
  flex-shrink: 0;
}

.api-notice-nao-oficial strong {
  display: block;
  font-size: 12.5px;
  font-weight: 700;
  color: #92400e;
  margin-bottom: 2px;
}

.api-notice-nao-oficial p {
  margin: 0;
  font-size: 12px;
  color: #78350f;
  line-height: 1.45;
}

.api-notice-nao-oficial u {
  text-decoration-thickness: 1.5px;
  text-underline-offset: 2px;
}

/* Variações do Box de Download */
.api-download-box.homologacao:hover {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-color: #f59e0b;
  box-shadow: 0 6px 18px rgba(245, 158, 11, 0.15);
}

.api-download-box.producao:hover {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: #16a34a;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.15);
}

.api-download-icon-circle.homologacao {
  color: #d97706;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.api-download-icon-circle.producao {
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.btn-download-action.homologacao {
  background: #d97706;
}

.api-download-box:hover .btn-download-action.homologacao {
  background: #b45309;
  box-shadow: 0 4px 12px rgba(180, 83, 9, 0.25);
}

.btn-download-action.producao {
  background: #15803d;
}

.api-download-box:hover .btn-download-action.producao {
  background: #166534;
  box-shadow: 0 4px 12px rgba(21, 128, 61, 0.25);
}

.api-file-ext.warning {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}

/* Tag de XSD no Card de Endpoint (Seção 2) */
.api-badge-tag-xsd {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 5px;
}

.api-badge-tag-xsd.homologacao {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
}

.api-badge-tag-xsd.producao {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

/* Endpoints Wrapper & Cards */
.api-endpoints-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.api-endpoint-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
}

.api-endpoint-card.homologacao {
  border-left: 4px solid #f59e0b;
}

.api-endpoint-card.producao {
  border-left: 4px solid #16a34a;
}

.api-endpoint-card.inativo {
  border-left: 4px solid #f59e0b;
}

.api-endpoint-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.api-endpoint-badge-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.api-badge-env {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 6px;
  letter-spacing: 0.3px;
}

.api-badge-env.homologacao {
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
}

.api-badge-env.producao {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.api-badge-env.inativo {
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
}

.api-env-help {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.api-endpoint-input-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.api-endpoint-code-box {
  flex: 1;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 9px 14px;
  overflow-x: auto;
}

.api-endpoint-code-box code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  color: #1e293b;
  word-break: break-all;
  user-select: all;
}

.btn-copy-url {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1.5px solid;
  flex-shrink: 0;
}

.btn-copy-url.homologacao {
  background: #ffffff;
  color: #b45309;
  border-color: #f59e0b;
}

.btn-copy-url.homologacao:hover:not(:disabled) {
  background: #fffbeb;
  border-color: #d97706;
  color: #92400e;
  transform: translateY(-1px);
}

.btn-copy-url.producao {
  background: #ffffff;
  color: #15803d;
  border-color: #22c55e;
}

.btn-copy-url.producao:hover:not(:disabled) {
  background: #f0fdf4;
  border-color: #16a34a;
  color: #14532d;
  transform: translateY(-1px);
}

.btn-copy-url.inativo {
  background: #ffffff;
  color: #b45309;
  border-color: #f59e0b;
}

.btn-copy-url.inativo:hover:not(:disabled) {
  background: #fffbeb;
  border-color: #d97706;
  color: #92400e;
  transform: translateY(-1px);
}

/* Dica de Compartilhamento */
.api-share-tip {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 10px;
  padding: 14px 18px;
  margin-top: 18px;
  font-size: 13px;
  color: #0369a1;
  line-height: 1.5;
}

.api-share-tip i {
  font-size: 20px;
  color: #0284c7;
  margin-top: 2px;
  flex-shrink: 0;
}

.api-share-tip strong {
  display: block;
  font-size: 13.5px;
  color: #0c4a6e;
  margin-bottom: 2px;
}

.api-share-tip p {
  margin: 0;
  font-size: 12.5px;
  color: #0369a1;
  line-height: 1.45;
}

/* Footer do Modal */
.api-modal-footer {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: flex-end;
}

/* Responsividade do Modal de APIs */
@media screen and (max-width: 768px) {
  .api-nav-pills {
    flex-direction: column;
  }

  .api-download-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .api-download-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .btn-download-action {
    width: 100%;
    justify-content: center;
  }

  .api-endpoint-input-group {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-copy-url {
    width: 100%;
  }
}
</style>
